import React from "react";

export const ICONS = {
  COLLABORATOR_SPACE_PAGE_ICON: "COLLABORATOR_SPACE_PAGE_ICON",
  FOLDERS_ICON: "FOLDERS_ICON",
  CLIENT_LIST_PAGE_ICON: "CLIENT_LIST_PAGE_ICON",
  COLLABORATOR_LIST_PAGE_ICON: "COLLABORATOR_LIST_PAGE_ICON",
  TIME_SHEET_PAGE_ICON: "TIME_SHEET_PAGE_ICON",
  CATEGORY_STATISTICS_ICON: "CATEGORY_STATISTICS_ICON",
  STATISTICS: "STATISTICS",
  BUDGET_PAGE_ICON: "BUDGET_PAGE_ICON",
  FILTER: "FILTER",
  UPLOAD: "UPLOAD",
  SETTING: "SETTING",
  CLOSE: "CLOSE",
  VALID: "VALID",
  REJECTE: "REJECTE",
  VerticalLineIcon: "VerticalLineIcon",
  SimpleArrowUp: "SimpleArrowUp",
  DoubleArrowUp: "DoubleArrowUp",
  AddIcon: "AddIcon",
  Garbage: "Garbage",
  PENCIL: "PENCIL",
  FINANCIAL_PAGE_ICON: "FINANCIAL_PAGE_ICON",
  CALENDAR: "CALENDAR",
  CloseIconCircle: "CloseIconCircle",
  CheckAuthorisationIcon: "CheckAuthorisationIcon",
  SettingIconEmpty: "SettingIconEmpty",
  REDIRECT: "REDIRECT",
  CheckMarkCircleIcon: "CheckMarkCircleIcon",
  CrossIcon: "CrossIcon"
};

export function SvgIcon({ icon, className }) {
  // eslint-disable-next-line default-case
  switch (icon) {
    case ICONS.COLLABORATOR_SPACE_PAGE_ICON: {
      return <CollaboratorSpaceIcon className={className} />;
    }
    case ICONS.FOLDERS_ICON: {
      return <FoldersIcon className={className} />;
    }
    case ICONS.CLIENT_LIST_PAGE_ICON: {
      return <ClientListIcon className={className} />;
    }
    case ICONS.COLLABORATOR_LIST_PAGE_ICON: {
      return <CollaboratorListIcon className={className} />;
    }
    case ICONS.TIME_SHEET_PAGE_ICON: {
      return <TimeSheetIcon className={className} />;
    }
    case ICONS.CATEGORY_STATISTICS_ICON: {
      return <CategoryStatisticsIcon className={className} />;
    }
    case ICONS.CAPACITY_PLANING: {
      return <CapacityPlaningIcon className={className} />;
    }
    case ICONS.STATISTICS: {
      return <StatisticsIcon className={className} />;
    }
    case ICONS.BUDGET_PAGE_ICON: {
      return <BudgetIcon className={className} />;
    }
    case ICONS.FILTER: {
      return <FilterIcon className={className} />;
    }
    case ICONS.SETTING: {
      return <SettingIcon className={className} />;
    }
    case ICONS.UPLOAD: {
      return <UploadIcon className={className} />;
    }
    case ICONS.CLOSE: {
      return <CloseIcon className={className} />;
    }
    case ICONS.COMMENT: {
      return <CommentIcon className={className} />;
    }
    case ICONS.REFRESH: {
      return <RefreshIcon className={className} />;
    }
    case ICONS.SimpleArrowUp: {
      return <SimpleArrowUp className={className} />;
    }
    case ICONS.ArrowRight: {
      return <ArrowRightIcon className={className} />;
    }
    case ICONS.VerticalLineIcon: {
      return <VerticalLineIcon className={className} />;
    }
    case ICONS.DoubleArrowUp: {
      return <DoubleArrowUp className={className} />;
    }
    case ICONS.CheckMark: {
      return <CheckMarkIcon className={className} />;
    }
    case ICONS.AddIcon: {
      return <AddIcon className={className} />;
    }
    case ICONS.CloseIconCircle: {
      return <CloseIconCircle className={className} />;
    }
    case ICONS.CheckAuthorisationIcon: {
      return <CheckAuthorisationIcon className={className} />;
    }
    case ICONS.SettingIconEmpty: {
      return <SettingIconEmpty className={className} />;
    }
    case ICONS.Garbage: {
      return <Garbage className={className} />;
    }
    case ICONS.PENCIL: {
      return <PencilIcon className={className} />;
    }
    case ICONS.VALID: {
      return <ValidIcon className={className} />;
    }
    case ICONS.REJECTE: {
      return <RejectIcon className={className} />;
    }
    case ICONS.FINANCIAL_PAGE_ICON: {
      return <FinancialIcon className={className} />;
    }
    case ICONS.CALENDAR: {
      return <CalendarIcon className={className} />;
    }
    case ICONS.REDIRECT: {
      return <RedirectIcon className={className} />;
    }
    case ICONS.CheckMarkCircleIcon: {
      return <CheckMarkCircleIcon className={className} />;
    }
    case ICONS.CrossIcon: {
      return <CrossIcon className={className} />;
    }
  }
}

export function BudgetIcon({ className, color, width, height }) {
  if (!color) {
    color = "#C7E8FE";
  }
  if (!width) {
    width = 18;
  }
  if (!height) {
    height = 20;
  }
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 18 20"
      fill="#18A0FB"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.0252 3.44443L10.9194 0.138173C10.3402 -0.175559 9.54385 0.0657731 9.23012 0.644971L5.6584 7.28161H1.31441C0.759349 7.28161 0.324951 7.71601 0.324951 8.27107V10.0087V19.0104C0.324951 19.5654 0.759349 19.9998 1.31441 19.9998H15.191C15.7461 19.9998 16.1805 19.5654 16.1805 19.0104V16.5005H16.5908C16.808 16.5005 16.9769 16.3316 16.9769 16.1144V13.2425C16.9769 13.0253 16.808 12.8564 16.5908 12.8564H16.1805V10.0328C16.1805 9.57427 15.8426 9.164 15.4082 9.06747L17.5319 5.13375C17.8457 4.53042 17.6285 3.78229 17.0252 3.44443ZM12.6812 1.9723L8.86812 9.04334H7.78212L11.8606 1.5379L12.6812 1.9723ZM9.92998 1.00697C10.0506 0.78977 10.3402 0.693237 10.5574 0.813903L11.1608 1.15177L6.91332 9.04334H5.586L9.92998 1.00697ZM1.07308 8.24694C1.07308 8.17454 1.16961 8.05387 1.29028 8.05387H5.224L4.69307 9.0192H1.29028C1.21788 9.0192 1.14548 9.0192 1.07308 9.04334V8.24694ZM15.3841 19.0104C15.3841 19.131 15.2876 19.2276 15.1669 19.2276H1.29028C1.16961 19.2276 1.07308 19.131 1.07308 19.0104V10.0328C1.07308 9.91213 1.16961 9.8156 1.29028 9.8156H4.9344H6.47893H9.30252H14.7325H15.1428C15.2634 9.8156 15.36 9.91213 15.36 10.0328V12.8564H13.8878C13.2362 12.8564 12.7294 13.3873 12.7294 14.0148V15.3421C12.7294 15.9937 13.2604 16.5005 13.8878 16.5005H15.3841V19.0104ZM16.1564 13.6287H16.1805V15.7282H16.1564H13.8878C13.6706 15.7282 13.5017 15.5593 13.5017 15.3421V14.0148C13.5017 13.7976 13.6706 13.6287 13.8878 13.6287H16.1564ZM16.8321 4.74762L14.5153 9.04334H9.73691L13.3569 2.35843L16.639 4.14429C16.8804 4.24082 16.9528 4.53042 16.8321 4.74762Z"
        fill="#18A0FB"
      />
    </svg>
  );
}

export function EntityIcon({ className, color }) {
  if (!color) {
    color = "#C7E8FE";
  }
  return (
    <svg
      width="16"
      height="20"
      viewBox="0 0 16 20"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.3316 16.6373L13.4431 14.2095C14.055 14.0267 14.5836 13.6353 14.9371 13.1034C15.3818 12.3347 15.1807 11.3966 14.9861 10.4903C14.8685 10.0248 14.7981 9.5486 14.776 9.06896C14.798 8.5889 14.8684 8.11225 14.9861 7.64634C15.1795 6.73952 15.3818 5.80197 14.9371 5.03448C14.4766 4.23876 13.5493 3.94424 12.6524 3.65997C12.2059 3.53695 11.7735 3.36762 11.3623 3.15472C10.9891 2.91266 10.6426 2.63179 10.3285 2.31679C9.66311 1.69921 8.90867 1 7.94846 1C6.98825 1 6.2338 1.69921 5.56811 2.31648C5.25416 2.63156 4.90774 2.91254 4.53467 3.15472C4.12346 3.36719 3.69119 3.5361 3.24487 3.65872C2.34798 3.943 1.42067 4.23752 0.960114 5.03324C0.51539 5.80197 0.716493 6.74014 0.91108 7.64634C1.02874 8.11229 1.09903 8.5889 1.12087 9.06896C1.09892 9.54903 1.02855 10.0257 0.910769 10.4916C0.717425 11.3984 0.51508 12.336 0.959804 13.1034C1.31375 13.6355 1.84293 14.0268 2.45536 14.2092L0.565356 16.637C0.460149 16.7723 0.484549 16.9673 0.619899 17.0725C0.684916 17.1231 0.767312 17.1457 0.849011 17.1354L3.06798 16.8583L3.61573 18.775C3.64782 18.8873 3.7403 18.9721 3.85501 18.9944C3.87445 18.9981 3.89419 19 3.91398 19C4.0098 19.0001 4.1003 18.9559 4.15915 18.8802L6.14101 16.331C6.62872 16.8058 7.26935 17.0918 7.94846 17.1379C8.62757 17.0918 9.2682 16.8058 9.75591 16.331L11.7378 18.8793C11.7964 18.9553 11.8869 18.9998 11.9829 19C12.0027 19 12.0225 18.9981 12.0419 18.9944C12.1566 18.9721 12.2491 18.8873 12.2812 18.775L12.8289 16.8586L15.0479 17.1358C15.218 17.1571 15.3731 17.0365 15.3945 16.8665C15.4047 16.7848 15.3821 16.7024 15.3316 16.6373ZM4.04432 18.0165L3.59153 16.4319C3.54944 16.2849 3.40652 16.1905 3.2548 16.2094L1.51687 16.4266L3.07449 14.4243L3.24611 14.4792C3.692 14.6019 4.12385 14.7708 4.53467 14.9832C4.90786 15.2253 5.25435 15.5061 5.56842 15.8211L5.67518 15.9198L4.04432 18.0165ZM7.94846 16.5172C7.23156 16.5172 6.62856 15.9586 5.98987 15.3665C5.6424 15.0193 5.25858 14.7106 4.84501 14.4457C4.39505 14.2101 3.92139 14.0229 3.43201 13.8871C2.61177 13.6267 1.83684 13.3809 1.4967 12.7931C1.17208 12.2317 1.33967 11.4493 1.51749 10.6207C1.64547 10.1125 1.72058 9.59256 1.74156 9.06896C1.72069 8.54537 1.6457 8.02539 1.5178 7.51724C1.33998 6.68893 1.17239 5.90655 1.49701 5.34483C1.83839 4.75703 2.61208 4.51124 3.43232 4.25086C3.92162 4.11501 4.39513 3.92775 4.84501 3.69224C5.25847 3.42728 5.64221 3.11857 5.98956 2.77145C6.62856 2.17931 7.23156 1.62069 7.94846 1.62069C8.66536 1.62069 9.26835 2.17931 9.90704 2.77145C10.2545 3.11861 10.6383 3.42728 11.0519 3.69224C11.5019 3.92779 11.9755 4.11505 12.4649 4.25086C13.2851 4.51124 14.0601 4.75703 14.4002 5.34483C14.7248 5.90624 14.5573 6.68862 14.3794 7.51724C14.2514 8.02539 14.1763 8.54537 14.1554 9.06896C14.1762 9.59256 14.2512 10.1125 14.3791 10.6207C14.5569 11.449 14.7245 12.2314 14.3999 12.7931C14.0585 13.3809 13.2848 13.6267 12.4646 13.8871C11.9753 14.0229 11.5018 14.2102 11.0519 14.4457C10.6385 14.7106 10.2547 15.0194 9.90736 15.3665C9.26836 15.9586 8.66536 16.5172 7.94846 16.5172ZM12.6437 16.2094C12.4919 16.1905 12.349 16.2849 12.3069 16.4319L11.8526 18.0165L10.222 15.9201L10.3288 15.8214C10.6428 15.5064 10.9892 15.2254 11.3623 14.9832C11.7735 14.7707 12.2057 14.6018 12.652 14.4792L12.8237 14.4243L14.3816 16.4266L12.6437 16.2094Z"
        fill={color}
      />
      <path
        d="M12.09 7.76759C11.9603 7.58936 11.7532 7.48389 11.5328 7.4838H9.42172L8.76655 5.47449C8.64763 5.11264 8.25789 4.91574 7.89603 5.03467C7.68789 5.10307 7.52461 5.26635 7.45621 5.47449L6.80276 7.4838H4.69C4.30909 7.48363 4.00017 7.7922 4 8.17311C3.99987 8.3938 4.10539 8.60117 4.28379 8.73104L5.99276 9.97242L5.34 11.9817C5.22224 12.344 5.42047 12.7331 5.78267 12.8508C5.99272 12.919 6.22272 12.8826 6.40138 12.7528L8.11138 11.5117L9.82069 12.7531C10.0615 12.932 10.3909 12.932 10.6317 12.7531C10.8761 12.5794 10.9778 12.2662 10.8821 11.9821L10.2293 9.97242L11.9383 8.73104C12.2463 8.5069 12.3142 8.07552 12.09 7.76759ZM9.62103 9.56207C9.50009 9.64996 9.44953 9.80578 9.49586 9.94793L10.2262 12.1955L8.31414 10.8066C8.19332 10.7188 8.02978 10.7188 7.90897 10.8066L5.9969 12.1955L6.7269 9.94793C6.77306 9.80586 6.72254 9.65026 6.60172 9.56242L4.69 8.17345H7.0531C7.2025 8.17345 7.33487 8.07725 7.38103 7.93518L8.11138 5.6876L8.84172 7.93483C8.88789 8.0769 9.02026 8.17311 9.16966 8.17311L11.5328 8.17345L9.62103 9.56207Z"
        fill={color}
      />
      <path
        d="M15.3316 16.6373L13.4431 14.2095C14.055 14.0267 14.5836 13.6353 14.9371 13.1034C15.3818 12.3347 15.1807 11.3966 14.9861 10.4903C14.8685 10.0248 14.7981 9.5486 14.776 9.06896C14.798 8.5889 14.8684 8.11225 14.9861 7.64634C15.1795 6.73952 15.3818 5.80197 14.9371 5.03448C14.4766 4.23876 13.5493 3.94424 12.6524 3.65997C12.2059 3.53695 11.7735 3.36762 11.3623 3.15472C10.9891 2.91266 10.6426 2.63179 10.3285 2.31679C9.66311 1.69921 8.90867 1 7.94846 1C6.98825 1 6.2338 1.69921 5.56811 2.31648C5.25416 2.63156 4.90774 2.91254 4.53467 3.15472C4.12346 3.36719 3.69119 3.5361 3.24487 3.65872C2.34798 3.943 1.42067 4.23752 0.960114 5.03324C0.51539 5.80197 0.716493 6.74014 0.91108 7.64634C1.02874 8.11229 1.09903 8.5889 1.12087 9.06896C1.09892 9.54903 1.02855 10.0257 0.910769 10.4916C0.717425 11.3984 0.51508 12.336 0.959804 13.1034C1.31375 13.6355 1.84293 14.0268 2.45536 14.2092L0.565356 16.637C0.460149 16.7723 0.484549 16.9673 0.619899 17.0725C0.684916 17.1231 0.767312 17.1457 0.849011 17.1354L3.06798 16.8583L3.61573 18.775C3.64782 18.8873 3.7403 18.9721 3.85501 18.9944C3.87445 18.9981 3.89419 19 3.91398 19C4.0098 19.0001 4.1003 18.9559 4.15915 18.8802L6.14101 16.331C6.62872 16.8058 7.26935 17.0918 7.94846 17.1379C8.62757 17.0918 9.2682 16.8058 9.75591 16.331L11.7378 18.8793C11.7964 18.9553 11.8869 18.9998 11.9829 19C12.0027 19 12.0225 18.9981 12.0419 18.9944C12.1566 18.9721 12.2491 18.8873 12.2812 18.775L12.8289 16.8586L15.0479 17.1358C15.218 17.1571 15.3731 17.0365 15.3945 16.8665C15.4047 16.7848 15.3821 16.7024 15.3316 16.6373ZM4.04432 18.0165L3.59153 16.4319C3.54944 16.2849 3.40652 16.1905 3.2548 16.2094L1.51687 16.4266L3.07449 14.4243L3.24611 14.4792C3.692 14.6019 4.12385 14.7708 4.53467 14.9832C4.90786 15.2253 5.25435 15.5061 5.56842 15.8211L5.67518 15.9198L4.04432 18.0165ZM7.94846 16.5172C7.23156 16.5172 6.62856 15.9586 5.98987 15.3665C5.6424 15.0193 5.25858 14.7106 4.84501 14.4457C4.39505 14.2101 3.92139 14.0229 3.43201 13.8871C2.61177 13.6267 1.83684 13.3809 1.4967 12.7931C1.17208 12.2317 1.33967 11.4493 1.51749 10.6207C1.64547 10.1125 1.72058 9.59256 1.74156 9.06896C1.72069 8.54537 1.6457 8.02539 1.5178 7.51724C1.33998 6.68893 1.17239 5.90655 1.49701 5.34483C1.83839 4.75703 2.61208 4.51124 3.43232 4.25086C3.92162 4.11501 4.39513 3.92775 4.84501 3.69224C5.25847 3.42728 5.64221 3.11857 5.98956 2.77145C6.62856 2.17931 7.23156 1.62069 7.94846 1.62069C8.66536 1.62069 9.26835 2.17931 9.90704 2.77145C10.2545 3.11861 10.6383 3.42728 11.0519 3.69224C11.5019 3.92779 11.9755 4.11505 12.4649 4.25086C13.2851 4.51124 14.0601 4.75703 14.4002 5.34483C14.7248 5.90624 14.5573 6.68862 14.3794 7.51724C14.2514 8.02539 14.1763 8.54537 14.1554 9.06896C14.1762 9.59256 14.2512 10.1125 14.3791 10.6207C14.5569 11.449 14.7245 12.2314 14.3999 12.7931C14.0585 13.3809 13.2848 13.6267 12.4646 13.8871C11.9753 14.0229 11.5018 14.2102 11.0519 14.4457C10.6385 14.7106 10.2547 15.0194 9.90736 15.3665C9.26836 15.9586 8.66536 16.5172 7.94846 16.5172ZM12.6437 16.2094C12.4919 16.1905 12.349 16.2849 12.3069 16.4319L11.8526 18.0165L10.222 15.9201L10.3288 15.8214C10.6428 15.5064 10.9892 15.2254 11.3623 14.9832C11.7735 14.7707 12.2057 14.6018 12.652 14.4792L12.8237 14.4243L14.3816 16.4266L12.6437 16.2094Z"
        stroke={color}
        strokeWidth="0.2"
      />
      <path
        d="M12.09 7.76759C11.9603 7.58936 11.7532 7.48389 11.5328 7.4838H9.42172L8.76655 5.47449C8.64763 5.11264 8.25789 4.91574 7.89603 5.03467C7.68789 5.10307 7.52461 5.26635 7.45621 5.47449L6.80276 7.4838H4.69C4.30909 7.48363 4.00017 7.7922 4 8.17311C3.99987 8.3938 4.10539 8.60117 4.28379 8.73104L5.99276 9.97242L5.34 11.9817C5.22224 12.344 5.42047 12.7331 5.78267 12.8508C5.99272 12.919 6.22272 12.8826 6.40138 12.7528L8.11138 11.5117L9.82069 12.7531C10.0615 12.932 10.3909 12.932 10.6317 12.7531C10.8761 12.5794 10.9778 12.2662 10.8821 11.9821L10.2293 9.97242L11.9383 8.73104C12.2463 8.5069 12.3142 8.07552 12.09 7.76759ZM9.62103 9.56207C9.50009 9.64996 9.44953 9.80578 9.49586 9.94793L10.2262 12.1955L8.31414 10.8066C8.19332 10.7188 8.02978 10.7188 7.90897 10.8066L5.9969 12.1955L6.7269 9.94793C6.77306 9.80586 6.72254 9.65026 6.60172 9.56242L4.69 8.17345H7.0531C7.2025 8.17345 7.33487 8.07725 7.38103 7.93518L8.11138 5.6876L8.84172 7.93483C8.88789 8.0769 9.02026 8.17311 9.16966 8.17311L11.5328 8.17345L9.62103 9.56207Z"
        stroke={color}
        strokeWidth="0.2"
      />
    </svg>
  );
}

export function CollaboratorSpaceIcon({ className }) {
  return (
    <svg
      className={className}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2 0.5C1.17157 0.5 0.5 1.17157 0.5 2V10C0.5 10.8284 1.17157 11.5 2 11.5H10C10.8284 11.5 11.5 10.8284 11.5 10V2C11.5 1.17157 10.8284 0.5 10 0.5H2ZM15 5.5C14.1716 5.5 13.5 6.17157 13.5 7V10C13.5 10.8284 14.1716 11.5 15 11.5H18C18.8284 11.5 19.5 10.8284 19.5 10V7C19.5 6.17157 18.8284 5.5 18 5.5H15ZM15 13.5C14.1716 13.5 13.5 14.1716 13.5 15V18C13.5 18.8284 14.1716 19.5 15 19.5H18C18.8284 19.5 19.5 18.8284 19.5 18V15C19.5 14.1716 18.8284 13.5 18 13.5H15ZM7 13.5C6.17157 13.5 5.5 14.1716 5.5 15V18C5.5 18.8284 6.17157 19.5 7 19.5H10C10.8284 19.5 11.5 18.8284 11.5 18V15C11.5 14.1716 10.8284 13.5 10 13.5H7Z"
        stroke="#C7E8FE"
      />
    </svg>
  );
}

export function ClientListIcon({ className, size }) {
  return (
    <svg
      className={className}
      width={size ? size : "38"}
      height={size ? size : "38"}
      viewBox="0 0 38 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M37.102 17.7803C36.5332 17.2556 35.7594 16.9314 34.979 16.8908C34.0927 16.845 33.2624 17.161 32.644 17.7797L28.4187 21.9606C28.3352 21.8159 28.2398 21.6794 28.1329 21.5527C27.613 20.9355 26.8529 20.5957 25.9927 20.5957H20.0778C18.9625 20.5957 17.8744 20.451 16.8441 20.166C14.1577 19.423 11.5914 19.9657 9.4219 21.7365C8.53969 22.4567 7.89607 23.24 7.48903 23.8112L6.42851 22.782C6.28906 22.6466 6.10003 22.5697 5.9055 22.5697C5.90376 22.5697 5.90231 22.5697 5.90057 22.5697C5.69908 22.5712 5.50425 22.655 5.36451 22.7999L0.208919 28.1521C0.0709186 28.2953 -0.00416986 28.4878 0.000178893 28.6867C0.00452765 28.8859 0.0877339 29.0749 0.231823 29.212L8.95166 37.515C9.09633 37.6527 9.28187 37.7214 9.46713 37.7214C9.66167 37.7214 9.8562 37.6457 10.0026 37.4955L15.1101 32.2556C15.2495 32.1124 15.3269 31.9167 15.3232 31.7166C15.3194 31.5195 15.2368 31.3293 15.0953 31.1919L14.6506 30.7605L15.6685 30.646C16.2842 30.5743 16.9105 30.5381 17.5303 30.5381H26.5296C27.992 30.5381 29.234 30.2183 30.2214 29.5875C30.2295 29.5822 30.2377 29.5767 30.2458 29.5712C30.5995 29.3254 30.9204 29.034 31.1993 28.7055L37.2638 21.571C38.3017 20.3501 38.2368 18.8266 37.102 17.7803ZM9.44771 35.923L1.80723 28.6478L5.92318 24.3748L13.519 31.7459L9.44771 35.923ZM36.1247 20.6026L30.0602 27.7375C29.8677 27.9639 29.6471 28.1651 29.4039 28.3356C28.6625 28.805 27.6957 29.0433 26.5296 29.0433H17.53C16.8531 29.0433 16.1686 29.083 15.4986 29.161L13.261 29.4121L8.57593 24.8656C8.9015 24.3829 9.50018 23.6027 10.3673 22.8947C12.17 21.4231 14.2151 20.9897 16.4454 21.6069C17.6057 21.9279 18.8277 22.0908 20.0778 22.0908H25.9927C27.055 22.0908 27.3385 23.011 27.3385 23.5546C27.3385 23.9518 27.2109 24.3298 26.9886 24.5919C26.7473 24.8757 26.4044 25.0195 25.9692 25.0195H20.8203C20.4074 25.0195 20.0729 25.3544 20.0729 25.7672C20.0729 26.1801 20.4074 26.5146 20.8203 26.5146H25.9692C26.8384 26.5146 27.6049 26.1754 28.1279 25.5596C28.5631 25.0477 28.8113 24.3745 28.8321 23.6549L33.6984 18.8397C34.3939 18.1442 35.4805 18.3187 36.0885 18.8794C36.4027 19.1693 36.8254 19.7784 36.1247 20.6026Z"
        fill="#3C4E64"
      />
      <path
        d="M18.489 25.568C18.3948 25.1659 17.9927 24.9168 17.5906 25.0108C17.1888 25.105 16.9392 25.5071 17.0337 25.9092L17.0406 25.9397C17.1215 26.2841 17.4285 26.5166 17.7677 26.5166C17.8243 26.5166 17.8817 26.5102 17.9391 26.4969C18.3412 26.4027 18.5905 26.0003 18.4963 25.5984L18.489 25.568Z"
        fill="#3C4E64"
      />
      <path
        d="M5.05263 16.0684H12.3365C12.7331 16.0684 13.1001 15.9396 13.3988 15.7222C13.6974 15.9396 14.0644 16.0684 14.461 16.0684H21.7452C22.1418 16.0684 22.5088 15.9396 22.8074 15.7222C23.1061 15.9396 23.4731 16.0684 23.8697 16.0684H31.1536C32.1515 16.0684 32.9632 15.2563 32.9632 14.2584V10.8617C32.9632 9.3362 32.1094 8.01099 30.8315 7.35722C31.4507 6.6104 31.8236 5.65251 31.8236 4.60881C31.8236 2.2312 29.8892 0.296875 27.5116 0.296875C25.134 0.296875 23.1997 2.2312 23.1997 4.60881C23.1997 5.65251 23.5725 6.61069 24.1918 7.35722C23.6395 7.64018 23.1666 8.04868 22.8074 8.54415C22.4482 8.04839 21.9754 7.63989 21.4228 7.35722C22.0421 6.61069 22.4149 5.65251 22.4149 4.60881C22.4149 2.2312 20.4806 0.296875 18.103 0.296875C15.7253 0.296875 13.791 2.2312 13.791 4.60881C13.791 5.65251 14.1641 6.61069 14.7834 7.35751C14.2308 7.64018 13.758 8.04868 13.3988 8.54444C13.0396 8.04868 12.5667 7.64018 12.0141 7.35722C12.6334 6.61069 13.0062 5.65251 13.0062 4.6091C13.0062 2.2312 11.0719 0.296875 8.69428 0.296875C6.31696 0.296875 4.38263 2.2312 4.38263 4.6091C4.38263 5.65251 4.75546 6.61069 5.37473 7.35751C4.09677 8.01128 3.24268 9.33678 3.24268 10.862V14.2584C3.24268 15.2563 4.05473 16.0684 5.05263 16.0684ZM27.5119 1.79198C29.065 1.79198 30.3288 3.05544 30.3288 4.60881C30.3288 6.1619 29.065 7.42565 27.5119 7.42565C25.9586 7.42565 24.6951 6.16219 24.6951 4.60881C24.6948 3.05544 25.9586 1.79198 27.5119 1.79198ZM25.5698 8.45688C26.154 8.75289 26.8135 8.92075 27.5116 8.92075C28.21 8.92075 28.8696 8.75289 29.4535 8.45688C30.6152 8.65924 31.4684 9.66033 31.4684 10.8617V14.2584C31.4684 14.4321 31.3272 14.5733 31.1536 14.5733H23.8697C23.6963 14.5733 23.5551 14.4321 23.5551 14.2584V10.8617C23.5548 9.66062 24.4084 8.65924 25.5698 8.45688ZM18.1032 1.79198C19.6563 1.79198 20.9201 3.05544 20.9201 4.60881C20.9201 6.1619 19.6563 7.42565 18.1032 7.42565C16.5499 7.42565 15.2864 6.16219 15.2864 4.60881C15.2864 3.05544 16.5499 1.79198 18.1032 1.79198ZM16.1614 8.45688C16.7453 8.75289 17.4048 8.92075 18.1032 8.92075C18.8017 8.92075 19.4609 8.75289 20.0451 8.45688C21.2065 8.65924 22.06 9.66033 22.06 10.8617V14.2584C22.06 14.4321 21.9188 14.5733 21.7452 14.5733H14.4613C14.2876 14.5733 14.1465 14.4321 14.1465 14.2584V10.8617C14.1465 9.66062 15 8.65924 16.1614 8.45688ZM8.69457 1.79198C10.2477 1.79198 11.5114 3.05544 11.5114 4.60881C11.5114 6.1619 10.2477 7.42565 8.69457 7.42565C7.14148 7.42565 5.87773 6.1619 5.87773 4.60881C5.87773 3.05544 7.14148 1.79198 8.69457 1.79198ZM4.73778 10.8617C4.73778 9.66062 5.59129 8.65924 6.7527 8.45688C7.33689 8.75289 7.99616 8.92075 8.69457 8.92075C9.39298 8.92075 10.0522 8.75289 10.6364 8.45688C11.7981 8.65924 12.6514 9.66033 12.6514 10.8617V14.2584C12.6514 14.4321 12.5102 14.5733 12.3365 14.5733H5.05263C4.87897 14.5733 4.73778 14.4321 4.73778 14.2584V10.8617Z"
        fill="#3C4E64"
      />
    </svg>
  );
}

export function CollaboratorListIcon({ className }) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M10 0C8.02219 0 6.08879 0.58649 4.4443 1.6853C2.79981 2.78412 1.51809 4.3459 0.761209 6.17316C0.00433286 8.00043 -0.1937 10.0111 0.192152 11.9509C0.578004 13.8907 1.53041 15.6725 2.92894 17.0711C4.32746 18.4696 6.10929 19.422 8.0491 19.8078C9.98891 20.1937 11.9996 19.9957 13.8268 19.2388C15.6541 18.4819 17.2159 17.2002 18.3147 15.5557C19.4135 13.9112 20 11.9778 20 10C20 7.34783 18.9464 4.8043 17.0711 2.92893C15.1957 1.05357 12.6522 0 10 0V0ZM10 19.1667C8.18701 19.1667 6.41473 18.629 4.90728 17.6218C3.39983 16.6146 2.22491 15.1829 1.53111 13.5079C0.837305 11.8329 0.655775 9.98983 1.00947 8.21167C1.36317 6.43351 2.23621 4.80017 3.51819 3.51819C4.80017 2.23621 6.43352 1.36317 8.21168 1.00947C9.98983 0.65577 11.8329 0.837301 13.5079 1.5311C15.1829 2.22491 16.6146 3.39982 17.6218 4.90727C18.6291 6.41472 19.1667 8.187 19.1667 10C19.1667 12.4311 18.2009 14.7627 16.4818 16.4818C14.7627 18.2009 12.4312 19.1667 10 19.1667Z"
        fill="#C7E8FE"
      />
      <path
        d="M10 10C8.4087 10 6.88258 10.587 5.75736 11.6318C4.63214 12.6767 4 14.0938 4 15.5714C4 15.6851 4.04863 15.7941 4.13518 15.8745C4.22174 15.9548 4.33913 16 4.46154 16C4.58395 16 4.70134 15.9548 4.7879 15.8745C4.87445 15.7941 4.92308 15.6851 4.92308 15.5714C4.92308 14.3211 5.45797 13.122 6.41007 12.2379C7.36218 11.3538 8.65352 10.8571 10 10.8571C11.3465 10.8571 12.6378 11.3538 13.5899 12.2379C14.542 13.122 15.0769 14.3211 15.0769 15.5714C15.0769 15.6851 15.1255 15.7941 15.2121 15.8745C15.2987 15.9548 15.4161 16 15.5385 16C15.6609 16 15.7783 15.9548 15.8648 15.8745C15.9514 15.7941 16 15.6851 16 15.5714C16 14.8398 15.8448 14.1153 15.5433 13.4393C15.2417 12.7634 14.7998 12.1492 14.2426 11.6318C13.6855 11.1145 13.0241 10.7041 12.2961 10.4241C11.5681 10.1441 10.7879 10 10 10V10Z"
        fill="#C7E8FE"
      />
      <path
        d="M10 9C10.4052 8.98976 10.8043 8.90404 11.1744 8.74775C11.5445 8.59147 11.8784 8.36768 12.1569 8.08921C12.4354 7.81075 12.6531 7.48306 12.7976 7.12492C12.942 6.76678 13.0103 6.38522 12.9986 6.00208C13.0109 5.6186 12.943 5.23659 12.7989 4.87797C12.6547 4.51935 12.4371 4.19117 12.1585 3.91226C11.8799 3.63334 11.5458 3.40918 11.1754 3.25264C10.805 3.09609 10.4056 3.01024 10 3C9.59443 3.01024 9.19498 3.09609 8.82457 3.25264C8.45416 3.40918 8.12009 3.63334 7.8415 3.91226C7.56291 4.19117 7.34529 4.51935 7.20113 4.87797C7.05697 5.23659 6.9891 5.6186 7.00142 6.00208C6.98969 6.38522 7.058 6.76678 7.20243 7.12492C7.34685 7.48306 7.56456 7.81075 7.84309 8.08921C8.12162 8.36768 8.4555 8.59147 8.82562 8.74775C9.19573 8.90404 9.59481 8.98976 10 9V9ZM10 3.83276C10.29 3.84293 10.5749 3.90721 10.8385 4.02189C11.1021 4.13657 11.3391 4.29939 11.536 4.50099C11.7328 4.70259 11.8855 4.93899 11.9854 5.1966C12.0853 5.45421 12.1303 5.72795 12.1179 6.00208C12.1297 6.27587 12.0842 6.54917 11.9841 6.8063C11.884 7.06343 11.7311 7.29933 11.5344 7.50049C11.3376 7.70164 11.1008 7.86408 10.8375 7.9785C10.5742 8.09292 10.2896 8.15706 10 8.16724C9.71043 8.15706 9.42583 8.09292 9.16253 7.9785C8.89923 7.86408 8.66241 7.70164 8.46564 7.50049C8.26888 7.29933 8.11604 7.06343 8.01589 6.8063C7.91575 6.54917 7.87027 6.27587 7.88206 6.00208C7.86967 5.72795 7.91471 5.45421 8.01459 5.1966C8.11446 4.93899 8.26721 4.70259 8.46403 4.50099C8.66085 4.29939 8.89788 4.13657 9.16148 4.02189C9.42507 3.90721 9.71004 3.84293 10 3.83276V3.83276Z"
        fill="#C7E8FE"
      />
    </svg>
  );
}

export function FoldersIcon({ className }) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0)">
        <path
          d="M19.7672 9.27704C19.4635 8.78662 18.9264 8.49396 18.3304 8.49396H16.8427V5.76492C16.8427 5.1062 16.2869 4.57047 15.6039 4.57047H8.32108C8.31039 4.57047 8.30322 4.56741 8.30032 4.56558L6.99692 2.74261C6.76575 2.41943 6.38458 2.22656 5.97717 2.22656H1.23871C0.555573 2.22656 0 2.76245 0 3.42102V16.5128C0 17.1869 0.569153 17.7354 1.26892 17.7354H16.0097C16.2393 17.7354 16.4377 17.6028 16.5337 17.4104L16.5341 17.4106L19.8373 10.7762C20.0769 10.2954 20.0505 9.73495 19.7672 9.27704ZM1.23871 3.39844H5.97717C6.01227 3.39844 6.03607 3.41385 6.04355 3.42438L7.34894 5.24994C7.56927 5.55817 7.93274 5.74234 8.32108 5.74234H15.6039C15.6448 5.74234 15.6656 5.76157 15.6708 5.76843V8.49396H5.06638C4.40872 8.49396 3.81058 8.86459 3.54248 9.43832L1.17188 14.5114V3.42453C1.17706 3.41766 1.19781 3.39844 1.23871 3.39844ZM18.7883 10.2539L15.6468 16.5634H1.5065L4.60419 9.93454C4.67926 9.77386 4.86511 9.66583 5.06638 9.66583H18.3304C18.5176 9.66583 18.6823 9.75113 18.7708 9.89395C18.8205 9.97437 18.8638 10.1021 18.7883 10.2539Z"
          fill="#C7E8FE"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function TimeSheetIcon({ className }) {
  return (
    <svg
      className={className}
      width="38"
      height="38"
      viewBox="0 0 38 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.6685 19H12.1421C11.7323 19 11.3999 19.3323 11.3999 19.7422C11.3999 20.1521 11.7323 20.4844 12.1421 20.4844H23.6685C24.0784 20.4844 24.4107 20.1521 24.4107 19.7422C24.4107 19.3323 24.0784 19 23.6685 19Z"
        fill="#3C4E64"
      />
      <path
        d="M23.6685 24.3438H12.1421C11.7323 24.3438 11.3999 24.676 11.3999 25.0859C11.3999 25.4958 11.7323 25.8281 12.1421 25.8281H23.6685C24.0784 25.8281 24.4107 25.4958 24.4107 25.0859C24.4107 24.676 24.0784 24.3438 23.6685 24.3438Z"
        fill="#3C4E64"
      />
      <path
        d="M23.6685 29.6875H12.1421C11.7323 29.6875 11.3999 30.0198 11.3999 30.4297C11.3999 30.8396 11.7323 31.1719 12.1421 31.1719H23.6685C24.0784 31.1719 24.4107 30.8396 24.4107 30.4297C24.4107 30.0198 24.0784 29.6875 23.6685 29.6875Z"
        fill="#3C4E64"
      />
      <path
        d="M33.2429 14.9561C33.2428 14.9533 33.2423 14.9505 33.2421 14.9477C33.2412 14.9359 33.2399 14.9254 33.2382 14.9158C33.2209 14.7498 33.1496 14.5905 33.0266 14.4674L25.3078 6.74864C25.1734 6.6143 24.9962 6.54001 24.8138 6.53244C24.8043 6.5317 24.7944 6.53125 24.783 6.53125H19.7485V5.19531C19.7485 2.33062 17.418 0 14.5532 0C11.6885 0 9.35791 2.33062 9.35791 5.19531V6.53125H7.7251C6.08813 6.53125 4.75635 7.86303 4.75635 9.5V35.0312C4.75635 36.6682 6.08813 38 7.7251 38H30.2752C31.9122 38 33.244 36.6682 33.244 35.0312V14.9922C33.244 14.9792 33.2435 14.9673 33.2429 14.9561ZM25.5252 9.06523L30.7098 14.25H27.195C26.2743 14.25 25.5251 13.5009 25.5251 12.5801V9.06523H25.5252ZM14.5531 1.48438C16.5994 1.48438 18.2641 3.1491 18.2641 5.19531V11.9905C18.2641 13.2364 17.2505 14.25 16.0046 14.25C14.7587 14.25 13.7451 13.2364 13.7451 11.9905V5.14032C13.7451 4.70376 14.1002 4.34862 14.5367 4.34862C14.9732 4.34862 15.3284 4.70376 15.3284 5.14032V11.8997C15.3284 12.3096 15.6607 12.6419 16.0706 12.6419C16.4804 12.6419 16.8127 12.3096 16.8127 11.8997V5.14032C16.8127 3.88528 15.7917 2.86425 14.5367 2.86425C13.2817 2.86425 12.2607 3.88528 12.2607 5.14032V6.53125H10.8423V5.19531H10.8422C10.8422 3.1491 12.5069 1.48438 14.5531 1.48438ZM31.7594 35.0312C31.7596 35.8497 31.0937 36.5156 30.2752 36.5156H7.72502C6.90654 36.5156 6.24065 35.8497 6.24065 35.0312V9.5C6.24065 8.68152 6.90654 8.01562 7.72502 8.01562H12.2606V11.9905C12.2606 14.0549 13.9401 15.7344 16.0045 15.7344C18.0689 15.7344 19.7484 14.0549 19.7484 11.9905V8.01562H24.0407V12.5801C24.0407 14.3194 25.4557 15.7344 27.195 15.7344H31.7594V35.0312V35.0312Z"
        fill="#3C4E64"
      />
    </svg>
  );
}

export function CategoryStatisticsIcon({ className }) {
  return (
    <svg
      width="38"
      height="38"
      viewBox="0 0 38 38"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.6219 9.70883H28.9383C29.443 9.70883 29.8512 9.30063 29.8512 8.79594C29.8512 8.29126 29.443 7.88306 28.9383 7.88306H18.6219C18.1172 7.88306 17.709 8.29126 17.709 8.79594C17.709 9.30063 18.1246 9.70883 18.6219 9.70883Z"
        fill="#3C4E64"
      />
      <path
        d="M10.198 9.97593C10.8457 9.97593 11.3707 9.45091 11.3707 8.80327C11.3707 8.15563 10.8457 7.63062 10.198 7.63062C9.55041 7.63062 9.02539 8.15563 9.02539 8.80327C9.02539 9.45091 9.55041 9.97593 10.198 9.97593Z"
        fill="#3C4E64"
      />
      <path
        d="M28.9383 18.1094H18.6219C18.1172 18.1094 17.709 18.5176 17.709 19.0223C17.709 19.527 18.1172 19.9352 18.6219 19.9352H28.9383C29.443 19.9352 29.8512 19.527 29.8512 19.0223C29.8512 18.5176 29.443 18.1094 28.9383 18.1094Z"
        fill="#3C4E64"
      />
      <path
        d="M10.198 20.188C10.8457 20.188 11.3707 19.6629 11.3707 19.0153C11.3707 18.3677 10.8457 17.8427 10.198 17.8427C9.55041 17.8427 9.02539 18.3677 9.02539 19.0153C9.02539 19.6629 9.55041 20.188 10.198 20.188Z"
        fill="#3C4E64"
      />
      <path
        d="M28.9383 28.3303H18.6219C18.1172 28.3303 17.709 28.7385 17.709 29.2432C17.709 29.7479 18.1172 30.1561 18.6219 30.1561H28.9383C29.443 30.1561 29.8512 29.7479 29.8512 29.2432C29.8512 28.7385 29.443 28.3303 28.9383 28.3303Z"
        fill="#3C4E64"
      />
      <path
        d="M10.198 30.4073C10.8457 30.4073 11.3707 29.8823 11.3707 29.2347C11.3707 28.587 10.8457 28.062 10.198 28.062C9.55041 28.062 9.02539 28.587 9.02539 29.2347C9.02539 29.8823 9.55041 30.4073 10.198 30.4073Z"
        fill="#3C4E64"
      />
      <path
        d="M37.1319 34.3118V3.68914C37.1319 3.18445 36.7237 2.77625 36.219 2.77625H1.77412C1.26943 2.77625 0.868652 3.18445 0.868652 3.68914V34.3044C0.868652 34.8091 1.27686 35.2173 1.77412 35.2173H36.2265C36.7312 35.2173 37.1319 34.8091 37.1319 34.3118ZM2.68701 14.8219H35.321V23.2235H2.68701V14.8219ZM35.3136 4.60203V13.0036H2.68701V4.60203H35.3136ZM2.68701 33.3989V25.0344H35.321V33.3989H2.68701Z"
        fill="#3C4E64"
      />
    </svg>
  );
}

export function CapacityPlaningIcon({ className }) {
  return (
    <svg
      width="18"
      height="20"
      viewBox="0 0 18 20"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.882 10.9128L13.7026 11.2741C13.7666 12.2972 14.6478 13.0746 15.6709 13.0107C16.694 12.9467 17.4715 12.0655 17.4075 11.0424C17.3435 10.0193 16.4623 9.24181 15.4392 9.30578C14.7759 9.34726 14.1855 9.74016 13.8911 10.336L12.007 9.96206C11.9866 9.24841 11.7104 8.56587 11.2289 8.03873L13.7687 4.451C14.9447 4.96107 16.3116 4.42115 16.8216 3.24514C17.3316 2.06914 16.7917 0.702235 15.6157 0.192218C14.4397 -0.317799 13.0728 0.222073 12.5628 1.39808C12.1969 2.2419 12.3636 3.22218 12.9881 3.89745L10.4785 7.44269C9.27781 6.76885 7.77192 7.00458 6.83461 8.01308L3.54597 5.45912C3.9802 4.52818 3.5775 3.42154 2.6466 2.98731C1.71565 2.55308 0.609021 2.95578 0.17479 3.88668C-0.259442 4.81763 0.143261 5.92426 1.07416 6.3585C1.67809 6.6402 2.38661 6.57724 2.93146 6.19348L6.30058 8.80988C5.75937 9.99196 6.04595 11.3884 7.00905 12.2617L4.9909 15.1159C3.79949 14.4516 2.29518 14.879 1.63097 16.0704C0.96675 17.2618 1.39409 18.7661 2.5855 19.4303C3.77691 20.0946 5.28122 19.6672 5.94544 18.4758C6.43244 17.6023 6.3446 16.5213 5.72291 15.7378L7.81125 12.7842C8.53891 13.107 9.36546 13.1252 10.1066 12.8347L12.6031 16.5226C11.8397 17.3921 11.9257 18.7158 12.7952 19.4792C13.6647 20.2427 14.9884 20.1567 15.7518 19.2872C16.5153 18.4177 16.4292 17.0939 15.5598 16.3305C14.9619 15.8056 14.1183 15.6646 13.3822 15.9666L10.9317 12.3466C11.3817 11.9717 11.7121 11.4733 11.882 10.9128ZM15.5542 10.259C16.0505 10.259 16.4529 10.6614 16.4529 11.1577C16.4529 11.6541 16.0505 12.0564 15.5542 12.0564C15.0578 12.0564 14.6555 11.6541 14.6555 11.1577C14.6559 10.6615 15.058 10.2594 15.5542 10.259ZM14.6859 0.968152C15.4359 0.9682 16.0438 1.57615 16.0438 2.32606C16.0437 3.07597 15.4358 3.68392 14.6858 3.68387C13.9359 3.68382 13.328 3.07592 13.328 2.32601C13.3289 1.57639 13.9364 0.968965 14.6859 0.968152ZM1.86373 5.57567C1.36763 5.5751 0.965602 5.17306 0.965028 4.67697C0.965028 4.18064 1.3674 3.77827 1.86373 3.77827C2.36006 3.77827 2.76243 4.18064 2.76243 4.67697C2.76243 5.1733 2.36011 5.57567 1.86373 5.57567ZM3.79442 18.7738C2.96251 18.7738 2.28815 18.0994 2.2882 17.2675C2.28825 16.4356 2.96261 15.7612 3.79452 15.7613C4.62638 15.7613 5.30074 16.4357 5.30074 17.2675C5.29983 18.0991 4.62595 18.7729 3.79442 18.7738ZM14.1771 16.7668C14.8074 16.7675 15.3181 17.2783 15.3188 17.9086C15.3188 18.5391 14.8077 19.0503 14.1771 19.0503C13.5465 19.0503 13.0353 18.5391 13.0353 17.9086C13.0353 17.278 13.5465 16.7668 14.1771 16.7668ZM9.01941 12.0834C7.89723 12.0822 6.98781 11.1727 6.98657 10.0506C6.98657 8.92786 7.8967 8.01772 9.01941 8.01772C10.1421 8.01772 11.0522 8.92786 11.0522 10.0506C11.0522 11.1733 10.1421 12.0834 9.01941 12.0834Z"
        fill="#C7E8FE"
      />
    </svg>
  );
}

export function PolygonDownIcon({ className }) {
  return (
    <svg
      width="14"
      height="8"
      viewBox="0 0 14 8"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M7 8L0.937822 0.5L13.0622 0.500001L7 8Z" fill="#29394D" />
    </svg>
  );
}

export function CommentIcon({ fill }) {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.0681 2.93132C15.1794 1.04271 12.6711 0 9.99938 0C7.32769 0 4.81931 1.04271 2.93071 2.93132C-0.712511 6.57454 -0.97633 12.3953 2.26906 16.34C1.82099 17.2571 1.29335 17.8685 0.694525 18.1616C0.330203 18.3417 0.12501 18.7353 0.183637 19.1374C0.246451 19.5436 0.556334 19.8576 0.962531 19.9204C1.18447 19.9539 1.42317 19.9749 1.67024 19.9749C2.8972 19.9749 4.18699 19.5519 5.2632 18.8107C6.71211 19.5896 8.34109 20 9.99938 20C12.6711 20 15.1794 18.9615 17.0681 17.0729C18.9567 15.1843 19.9952 12.6717 19.9952 10.0042C19.9952 7.33668 18.9567 4.81993 17.0681 2.93132ZM16.2682 16.2688C14.5932 17.9439 12.3654 18.8652 9.99938 18.8652C8.41647 18.8652 6.86287 18.4422 5.51027 17.6466C5.42233 17.5963 5.32183 17.567 5.22551 17.567C5.10407 17.567 4.97844 17.6089 4.87794 17.6843C3.59653 18.6767 2.30675 18.8233 1.74143 18.8358C2.41563 18.3333 2.98096 17.5544 3.45416 16.4698C3.5421 16.2688 3.50441 16.0343 3.35784 15.8668C0.259014 12.366 0.42233 7.03099 3.73054 3.72278C5.40558 2.04774 7.63339 1.12647 9.99938 1.12647C12.3654 1.12647 14.5932 2.04774 16.2682 3.72278C19.7272 7.18593 19.7272 12.8141 16.2682 16.2688Z"
        fill={fill}
      />
      <path
        d="M14.1867 6.7002H5.81148C5.49741 6.7002 5.24615 6.95145 5.24615 7.26552C5.24615 7.57959 5.49741 7.83085 5.81148 7.83085H14.1867C14.5008 7.83085 14.752 7.57959 14.752 7.26552C14.752 6.95145 14.4966 6.7002 14.1867 6.7002Z"
        fill={fill}
      />
      <path
        d="M14.1867 9.43457H5.81148C5.49741 9.43457 5.24615 9.68583 5.24615 9.9999C5.24615 10.314 5.49741 10.5652 5.81148 10.5652H14.1867C14.5008 10.5652 14.752 10.314 14.752 9.9999C14.752 9.68583 14.4966 9.43457 14.1867 9.43457Z"
        fill={fill}
      />
      <path
        d="M14.1867 12.1689H5.81148C5.49741 12.1689 5.24615 12.4202 5.24615 12.7343C5.24615 13.0483 5.49741 13.2996 5.81148 13.2996H14.1867C14.5008 13.2996 14.752 13.0483 14.752 12.7343C14.752 12.4202 14.4966 12.1689 14.1867 12.1689Z"
        fill={fill}
      />
    </svg>
  );
}

export function PencilIcon({ className }) {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.0932 0.906185C11.8881 -0.302062 9.92824 -0.302062 8.72312 0.906185L0.710863 8.91641C0.64822 8.97906 0.609442 9.05961 0.59751 9.14613L0.00389841 13.5435C-0.0139994 13.6688 0.0307452 13.7942 0.117251 13.8807C0.191826 13.9552 0.29623 14 0.400634 14C0.418531 14 0.436429 14 0.454327 13.997L3.10321 13.639C3.32395 13.6092 3.47906 13.4063 3.44923 13.1856C3.4194 12.9648 3.21656 12.8097 2.99582 12.8395L0.871943 13.1259L1.28658 10.059L4.51415 13.287C4.58873 13.3616 4.69313 13.4063 4.79753 13.4063C4.90194 13.4063 5.00634 13.3646 5.08092 13.287L13.0932 5.27676C13.6778 4.69202 14 3.91636 14 3.08998C14 2.2636 13.6778 1.48793 13.0932 0.906185ZM8.87824 1.89068L10.2236 3.23616L2.9123 10.5483L1.56698 9.20281L8.87824 1.89068ZM4.80052 12.4338L3.48503 11.1181L10.7963 3.80598L12.1118 5.12162L4.80052 12.4338ZM12.6726 4.54584L9.45395 1.32683C9.86262 0.989718 10.3727 0.804752 10.9096 0.804752C11.5212 0.804752 12.0939 1.04342 12.5264 1.47302C12.9589 1.90262 13.1946 2.4784 13.1946 3.08998C13.1946 3.62996 13.0097 4.13713 12.6726 4.54584Z"
        fill="#18A0FB"
      />
    </svg>
  );
}

export function UserIcon({ className, size }) {
  return (
    <svg
      width={size ? size : "14"}
      height={size ? size : "14"}
      viewBox="0 0 17 17"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.60427 9.02126C3.15125 8.47428 3.89312 8.16699 4.66667 8.16699H9.33333C10.1069 8.16699 10.8487 8.47428 11.3957 9.02126C11.9427 9.56825 12.25 10.3101 12.25 11.0837V12.2503C12.25 12.5725 11.9888 12.8337 11.6667 12.8337C11.3445 12.8337 11.0833 12.5725 11.0833 12.2503V11.0837C11.0833 10.6195 10.899 10.1744 10.5708 9.84622C10.2426 9.51803 9.79746 9.33366 9.33333 9.33366H4.66667C4.20254 9.33366 3.75742 9.51803 3.42923 9.84622C3.10104 10.1744 2.91667 10.6195 2.91667 11.0837V12.2503C2.91667 12.5725 2.6555 12.8337 2.33333 12.8337C2.01117 12.8337 1.75 12.5725 1.75 12.2503V11.0837C1.75 10.3101 2.05729 9.56825 2.60427 9.02126Z"
        fill="#29394D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.99992 2.33366C6.03342 2.33366 5.24992 3.11716 5.24992 4.08366C5.24992 5.05016 6.03342 5.83366 6.99992 5.83366C7.96642 5.83366 8.74992 5.05016 8.74992 4.08366C8.74992 3.11716 7.96642 2.33366 6.99992 2.33366ZM4.08325 4.08366C4.08325 2.47283 5.38909 1.16699 6.99992 1.16699C8.61075 1.16699 9.91658 2.47283 9.91658 4.08366C9.91658 5.69449 8.61075 7.00033 6.99992 7.00033C5.38909 7.00033 4.08325 5.69449 4.08325 4.08366Z"
        fill="#29394D"
      />
    </svg>
  );
}

export function UsersIcon({ className, size }) {
  return (
    <svg
      width={size ? size : "14"}
      height={size ? size : "14"}
      viewBox="0 0 24 24"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.46447 15.4645C2.40215 14.5268 3.67392 14 5 14H13C14.3261 14 15.5979 14.5268 16.5355 15.4645C17.4732 16.4021 18 17.6739 18 19V21C18 21.5523 17.5523 22 17 22C16.4477 22 16 21.5523 16 21V19C16 18.2044 15.6839 17.4413 15.1213 16.8787C14.5587 16.3161 13.7956 16 13 16H5C4.20435 16 3.44129 16.3161 2.87868 16.8787C2.31607 17.4413 2 18.2044 2 19V21C2 21.5523 1.55228 22 1 22C0.447715 22 0 21.5523 0 21V19C0 17.6739 0.526784 16.4021 1.46447 15.4645Z"
        fill="#29394D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 4C7.34315 4 6 5.34315 6 7C6 8.65685 7.34315 10 9 10C10.6569 10 12 8.65685 12 7C12 5.34315 10.6569 4 9 4ZM4 7C4 4.23858 6.23858 2 9 2C11.7614 2 14 4.23858 14 7C14 9.76142 11.7614 12 9 12C6.23858 12 4 9.76142 4 7Z"
        fill="#29394D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.0318 14.8801C19.1698 14.3454 19.7153 14.0238 20.25 14.1619C21.3227 14.4388 22.273 15.0642 22.9517 15.9398C23.6304 16.8153 23.9992 17.8915 24 18.9994L24 21.0001C24 21.5524 23.5523 22.0001 23 22.0001C22.4477 22.0001 22 21.5524 22 21.0001L22 19.0009C22 19.0008 22 19.001 22 19.0009C21.9994 18.3363 21.7782 17.6904 21.371 17.1651C20.9638 16.6398 20.3936 16.2645 19.75 16.0984C19.2153 15.9603 18.8937 15.4149 19.0318 14.8801Z"
        fill="#29394D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.0312 2.88208C15.1682 2.34706 15.713 2.02439 16.248 2.16137C17.3236 2.43675 18.2768 3.06225 18.9576 3.93926C19.6383 4.81627 20.0078 5.89491 20.0078 7.00512C20.0078 8.11534 19.6383 9.19397 18.9576 10.071C18.2768 10.948 17.3236 11.5735 16.248 11.8489C15.713 11.9859 15.1682 11.6632 15.0312 11.1282C14.8943 10.5931 15.2169 10.0484 15.752 9.91137C16.3973 9.74615 16.9692 9.37085 17.3777 8.84464C17.7861 8.31843 18.0078 7.67125 18.0078 7.00512C18.0078 6.339 17.7861 5.69181 17.3777 5.16561C16.9692 4.6394 16.3973 4.2641 15.752 4.09887C15.2169 3.96189 14.8943 3.41711 15.0312 2.88208Z"
        fill="#29394D"
      />
    </svg>
  );
}

export function ProgressionIcon({ className }) {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.19224 12.6773C3.90283 12.3879 3.90565 11.9159 4.19854 11.623L11.6232 4.19837C11.9161 3.90548 12.3881 3.90265 12.6775 4.19207C12.9669 4.48148 12.9641 4.95353 12.6712 5.24643L5.2466 12.671C4.95371 12.9639 4.48166 12.9668 4.19224 12.6773Z"
        fill="#2AF1E2"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.02073 4.77159C4.02319 4.35984 4.35898 4.02405 4.77073 4.02159L12.1512 3.97748C12.563 3.97502 12.8948 4.30682 12.8923 4.71857L12.8482 12.0991C12.8458 12.5108 12.51 12.8466 12.0982 12.8491C11.6865 12.8515 11.3547 12.5197 11.3571 12.108L11.3968 5.47303L4.76182 5.51268C4.35006 5.51514 4.01827 5.18334 4.02073 4.77159Z"
        fill="#2AF1E2"
      />
    </svg>
  );
}

export function RegressionIcon({ className }) {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.19252 4.192C4.48194 3.90258 4.95399 3.90541 5.24688 4.1983L12.6715 11.6229C12.9644 11.9158 12.9672 12.3879 12.6778 12.6773C12.3884 12.9667 11.9163 12.9639 11.6234 12.671L4.19882 5.24636C3.90593 4.95346 3.90311 4.48141 4.19252 4.192Z"
        fill="#FD728D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.0985 4.02073C12.5103 4.02319 12.8461 4.35898 12.8485 4.77073L12.8926 12.1512C12.8951 12.563 12.5633 12.8948 12.1515 12.8923L4.77103 12.8482C4.35928 12.8458 4.02349 12.51 4.02103 12.0982C4.01857 11.6865 4.35037 11.3547 4.76212 11.3571L11.3971 11.3968L11.3574 4.76182C11.355 4.35006 11.6868 4.01827 12.0985 4.02073Z"
        fill="#FD728D"
      />
    </svg>
  );
}

export function ValidIcon({ fill }) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 2.82812C6.94243 2.82812 2.82849 6.94263 2.82849 11.9999C2.82849 17.0571 6.94243 21.1714 12 21.1714C17.0573 21.1714 21.1715 17.0571 21.1715 11.9999C21.1715 6.94267 17.0573 2.82812 12 2.82812ZM12 19.7247C7.74043 19.7247 4.27519 16.2592 4.27519 11.9999C4.27519 7.74034 7.74043 4.27511 12 4.27511C16.2596 4.27511 19.7248 7.74034 19.7248 11.9999C19.7248 16.2592 16.2596 19.7247 12 19.7247Z"
        fill={fill ? fill : "#3C4E64"}
      />
      <path
        d="M16.3414 8.17325L10.4648 14.1607L7.55303 12.0522C7.18356 11.7846 6.66653 11.8673 6.39841 12.2368C6.13085 12.6068 6.21353 13.1235 6.58328 13.3914L10.0716 15.9172C10.2172 16.0228 10.387 16.0743 10.5564 16.0743C10.7718 16.0743 10.986 15.9905 11.1463 15.8268L17.5213 9.33153C17.8412 9.00575 17.8365 8.48234 17.5102 8.16242C17.185 7.84278 16.6613 7.84751 16.3414 8.17325Z"
        fill={fill ? fill : "#3C4E64"}
      />
    </svg>
  );
}

export function RejectIcon({ fill }) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.9999 21.5789C17.282 21.5789 21.579 17.2819 21.579 12C21.579 6.71816 17.282 2.4209 11.9999 2.4209C6.71802 2.4209 2.42108 6.71821 2.42108 12C2.42108 17.2819 6.71802 21.5789 11.9999 21.5789ZM11.9999 3.93215C16.4486 3.93215 20.0682 7.55132 20.0682 12C20.0682 16.4484 16.4486 20.068 11.9999 20.068C7.55146 20.068 3.93233 16.4484 3.93233 12C3.93228 7.55132 7.55141 3.93215 11.9999 3.93215Z"
        fill={fill ? fill : "#3C4E64"}
      />
      <path
        d="M8.06612 16.0086C8.23422 16.1738 8.45284 16.2556 8.67095 16.2556C8.89483 16.2556 9.11814 16.1694 9.28741 15.9973L11.9998 13.2329L14.7129 15.9973C14.882 16.1694 15.1054 16.2556 15.3291 16.2556C15.5474 16.2556 15.7658 16.1738 15.9339 16.0086C16.2744 15.6746 16.2793 15.1277 15.9452 14.7875L13.2097 12.0006L15.9452 9.21338C16.2793 8.87316 16.2743 8.3265 15.9339 7.99242C15.5939 7.65853 15.0473 7.66345 14.7128 8.00367L11.9998 10.7679L9.28736 8.00367C8.95291 7.66317 8.40625 7.65853 8.06603 7.99242C7.72581 8.3265 7.72061 8.87316 8.05497 9.21338L10.7902 12.0006L8.05497 14.7875C7.7207 15.1277 7.7259 15.6746 8.06612 16.0086Z"
        fill={fill ? fill : "#3C4E64"}
      />
    </svg>
  );
}

export function CheckMarkIcon({ className }) {
  return (
    <svg
      width="10"
      height="10"
      viewBox="0 0 10 10"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.78212 9.99999C3.47126 9.99999 3.17726 9.85456 2.98826 9.60514L0.435689 6.23414C0.103689 5.79571 0.190118 5.17142 0.628547 4.83928C1.06769 4.50699 1.69155 4.59399 2.02369 5.03213L3.70255 7.24899L7.92498 0.469277C8.21569 0.00284835 8.82955 -0.139866 9.29698 0.15042C9.76383 0.440991 9.9064 1.05528 9.61555 1.52213L4.62755 9.53071C4.45426 9.80914 4.15512 9.98428 3.82755 9.99914C3.81226 9.99971 3.79726 9.99999 3.78212 9.99999Z"
        fill="white"
      />
    </svg>
  );
}

export function PolygonUpIcon({ className }) {
  return (
    <svg
      width="10"
      height="8"
      viewBox="0 0 10 8"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.22229 0.962171C4.62253 0.466996 5.37747 0.466996 5.77771 0.962171L9.74578 5.87138C10.2744 6.52532 9.80892 7.5 8.96807 7.5L1.03193 7.5C0.191083 7.5 -0.274355 6.52532 0.254219 5.87138L4.22229 0.962171Z"
        fill="#3C4E64"
      />
    </svg>
  );
}

export function HistoryIcon({ className, size, fill }) {
  return (
    <svg
      width={size ? size : "14"}
      height={size ? size : "14"}
      viewBox="0 0 14 14"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.54688 3.77344V6.77348L9.53775 8.76436C9.75133 8.97794 9.75133 9.32419 9.53775 9.53775C9.32416 9.75133 8.97791 9.7513 8.76436 9.53775L6.6133 7.3867C6.51074 7.28416 6.45312 7.14503 6.45312 7V3.77344C6.45312 3.4714 6.69796 3.22656 7 3.22656C7.30204 3.22656 7.54688 3.4714 7.54688 3.77344ZM9.15105 0H4.84895C3.70352 0 2.57348 0.402555 1.66931 1.18885V0.546875C1.66931 0.244836 1.42447 0 1.12243 0C0.820395 0 0.575559 0.244836 0.575559 0.546875V2.69793C0.575559 2.99996 0.8225 3.2448 1.12243 3.2448H3.27348C3.57552 3.2448 3.82036 2.99996 3.82036 2.69793C3.82036 2.39589 3.57552 2.15105 3.27348 2.15105H2.23899C2.93117 1.48373 3.86553 1.09375 4.84895 1.09375H9.15102C11.2217 1.09375 12.9062 2.77832 12.9062 4.84895V9.15102C12.9062 11.2217 11.2217 12.9062 9.15105 12.9062H4.84895C2.77832 12.9062 1.09375 11.2217 1.09375 9.15105V7C1.09375 6.69796 0.848914 6.45312 0.546875 6.45312C0.244836 6.45312 0 6.69796 0 7V9.15105C0 11.8248 2.17522 14 4.84895 14H9.15102C11.8248 14 14 11.8248 14 9.15105V4.84895C14 2.17522 11.8248 0 9.15105 0V0Z"
        fill={fill ? fill : "#29394D"}
      />
    </svg>
  );
}

export function ToolIcon({ className, size }) {
  return (
    <svg
      className={className}
      width={size ? size : "31"}
      height={size ? size : "31"}
      viewBox={size ? `0 0 ${size} ${size}` : "0 0 31 31"}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.457 3.28976C20.7728 3.21244 20.0771 3.23485 19.3919 3.35969C17.9753 3.61779 16.6711 4.30147 15.6529 5.31962C14.6348 6.33777 13.9511 7.64204 13.693 9.0586C13.4349 10.4752 13.6146 11.9367 14.2083 13.2486C14.4514 13.7858 14.3363 14.4174 13.9193 14.8343L4.13015 24.6235C3.83224 24.9214 3.66488 25.3255 3.66488 25.7468C3.66488 26.1681 3.83224 26.5721 4.13015 26.87C4.42806 27.168 4.83211 27.3353 5.25341 27.3353C5.67472 27.3353 6.07877 27.168 6.37668 26.87L16.1658 17.0809C16.5828 16.6639 17.2144 16.5488 17.7516 16.7919C19.0635 17.3856 20.525 17.5653 21.9416 17.3072C23.3582 17.0491 24.6624 16.3654 25.6806 15.3473C26.6987 14.3291 27.3824 13.0249 27.6405 11.6083C27.7654 10.9231 27.7878 10.2274 27.7104 9.54323L24.0668 13.1869C23.5372 13.706 22.825 13.9967 22.0834 13.9967C21.3418 13.9967 20.6297 13.706 20.1001 13.1868L20.09 13.1769L17.8133 10.9002C17.2942 10.3705 17.0035 9.65842 17.0035 8.91678C17.0035 8.17514 17.2942 7.46308 17.8134 6.93345L17.8233 6.92333L21.457 3.28976ZM18.884 0.572245C20.8672 0.210904 22.9134 0.462538 24.75 1.29361C25.1737 1.48534 25.4763 1.87282 25.5596 2.33034C25.643 2.78787 25.4965 3.25717 25.1677 3.58602L19.8369 8.91678L22.0834 11.1633L27.4142 5.83255C27.743 5.5037 28.2123 5.3572 28.6699 5.44056C29.1274 5.52392 29.5149 5.82653 29.7066 6.25023C30.5377 8.08678 30.7893 10.133 30.428 12.1162C30.0666 14.0994 29.1095 15.9253 27.684 17.3507C26.2586 18.7762 24.4327 19.7333 22.4495 20.0947C20.7956 20.396 19.0979 20.271 17.5145 19.7392L8.38015 28.8735C7.55089 29.7028 6.42617 30.1686 5.25341 30.1686C4.08066 30.1686 2.95594 29.7028 2.12668 28.8735C1.29742 28.0443 0.831543 26.9195 0.831543 25.7468C0.831543 24.574 1.29742 23.4493 2.12668 22.62L11.261 13.4857C10.7292 11.9023 10.6042 10.2046 10.9055 8.55072C11.2669 6.56753 12.224 4.74156 13.6495 3.31615C15.0749 1.89074 16.9008 0.933586 18.884 0.572245Z"
        fill="#B2BCC6"
      />
    </svg>
  );
}

export function SettingIcon({ className, fill, size }) {
  return (
    <svg
      className={className}
      width={size ? size : "14"}
      height={size ? size : "14"}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.4877 5.98128L12.1009 5.74993C12.0001 5.33785 11.8532 4.94394 11.6618 4.57654L12.5496 3.47576C12.7384 3.24312 12.7298 2.9084 12.5307 2.68387L11.9792 2.06313C11.7792 1.83883 11.4477 1.7914 11.1948 1.95118L10.0088 2.69672C9.48716 2.33226 8.89627 2.06313 8.25885 1.90696L8.02682 0.5127C7.97814 0.217473 7.72266 0.000854492 7.42276 0.000854492H6.59157C6.29228 0.000854492 6.03594 0.217473 5.98833 0.5127L5.75504 1.9074C5.22804 2.03642 4.73393 2.2447 4.28301 2.519L3.1551 1.71406C2.91201 1.54039 2.57813 1.56755 2.366 1.77923L1.77878 2.36687C1.5671 2.579 1.53994 2.91288 1.71406 3.15597L2.52088 4.28603C2.24916 4.73355 2.04302 5.22485 1.91401 5.74716L0.511814 5.9813C0.217041 6.02998 0 6.28548 0 6.58539V7.41593C0 7.71581 0.217041 7.97134 0.511814 8.02002L1.91401 8.25416C2.01996 8.68396 2.17377 9.09451 2.3782 9.47517L1.49444 10.5697C1.30626 10.8021 1.31417 11.1371 1.51324 11.3614L2.06438 11.9822C2.26433 12.2069 2.59605 12.2535 2.84898 12.0941L4.05207 11.3383C4.56114 11.6865 5.13704 11.9424 5.75504 12.0941L5.98833 13.4886C6.03596 13.7838 6.29228 14.0004 6.59157 14.0004H7.42276C7.72266 14.0004 7.97814 13.7838 8.02682 13.4886L8.25924 12.0941C8.77966 11.9668 9.26751 11.7622 9.71442 11.4926L10.8893 12.3317C11.132 12.506 11.4661 12.4786 11.678 12.2663L12.2655 11.6788C12.4769 11.4673 12.5055 11.1337 12.33 10.8901L11.4935 9.71737C11.766 9.26835 11.9732 8.77617 12.1014 8.25153L13.4882 8.01997C13.7838 7.97129 14 7.71578 14 7.41588V6.58534C13.9996 6.28548 13.7834 6.02998 13.4877 5.98128ZM7.02199 9.62559C5.57259 9.62559 4.39706 8.44984 4.39706 7.00066C4.39706 5.55126 5.57259 4.37573 7.02199 4.37573C8.47114 4.37573 9.64689 5.55126 9.64689 7.00066C9.64689 8.44984 8.47114 9.62559 7.02199 9.62559Z"
        fill={fill}
      />
    </svg>
  );
}

export function PlusIcon({ className, fill }) {
  return (
    <svg
      width="10"
      height="10"
      viewBox="0 0 10 10"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.4573 4.3023H5.69766V0.542634C5.69766 0.371366 5.46509 0 4.99998 0C4.53487 0 4.3023 0.371386 4.3023 0.542634V4.30232H0.542634C0.371386 4.3023 0 4.53487 0 4.99996C0 5.46505 0.371386 5.69764 0.542634 5.69764H4.30232V9.45732C4.30232 9.62855 4.53487 9.99996 5 9.99996C5.46513 9.99996 5.69768 9.62855 5.69768 9.45732V5.69764H9.45737C9.62859 5.69764 10 5.46509 10 4.99996C10 4.53483 9.62855 4.3023 9.4573 4.3023Z"
        fill="#6D7F92"
      />
    </svg>
  );
}

export function ResetIcon({ className, fill }) {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.5 2.25C1.91421 2.25 2.25 2.58579 2.25 3V6.75H6C6.41421 6.75 6.75 7.08579 6.75 7.5C6.75 7.91421 6.41421 8.25 6 8.25H1.5C1.08579 8.25 0.75 7.91421 0.75 7.5V3C0.75 2.58579 1.08579 2.25 1.5 2.25Z"
        fill="#6D7F92"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.70402 1.58097C10.3142 1.35442 11.9544 1.65732 13.3775 2.44401C14.8006 3.2307 15.9294 4.45858 16.594 5.94262C17.2585 7.42667 17.4228 9.08649 17.062 10.672C16.7012 12.2575 15.8349 13.6828 14.5936 14.7332C13.3523 15.7835 11.8032 16.402 10.1799 16.4954C8.55652 16.5889 6.94677 16.1522 5.59317 15.2512C4.23957 14.3502 3.21545 13.0337 2.67512 11.5C2.53748 11.1094 2.7426 10.6811 3.13328 10.5434C3.52396 10.4058 3.95224 10.6109 4.08988 11.0016C4.52215 12.2285 5.34144 13.2817 6.42432 14.0025C7.5072 14.7233 8.79501 15.0727 10.0937 14.9979C11.3924 14.9232 12.6316 14.4284 13.6246 13.5881C14.6177 12.7478 15.3107 11.6076 15.5994 10.3392C15.888 9.07076 15.7566 7.7429 15.225 6.55566C14.6933 5.36842 13.7902 4.38613 12.6518 3.75677C11.5133 3.12742 10.2012 2.8851 8.913 3.06634C7.62485 3.24758 6.43049 3.84254 5.50988 4.7616C5.50453 4.76694 5.4991 4.7722 5.49358 4.77738L2.01358 8.04738C1.71173 8.33103 1.23708 8.31626 0.953437 8.0144C0.669794 7.71254 0.68456 7.2379 0.98642 6.95425L4.45837 3.69182C5.60801 2.54767 7.09767 1.80697 8.70402 1.58097Z"
        fill="#6D7F92"
      />
    </svg>
  );
}

export function CercleAddIcon({ className, fill, size }) {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.1602 12.1597L12.1602 7.11772C12.1602 6.6536 12.5364 6.27736 13.0005 6.27739C13.4646 6.27739 13.8408 6.6536 13.8408 7.11771L13.8408 12.1597L18.8829 12.1597C19.347 12.1597 19.7232 12.5359 19.7232 13C19.7232 13.4641 19.347 13.8404 18.8829 13.8404L13.8409 13.8403L13.8409 18.8823C13.8409 19.3464 13.4646 19.7227 13.0006 19.7227C12.5365 19.7227 12.1603 19.3465 12.1603 18.8823L12.1603 13.8403L7.11825 13.8403C6.65416 13.8404 6.27792 13.4641 6.27792 13C6.27792 12.5359 6.65413 12.1597 7.11825 12.1597L12.1602 12.1597Z"
        fill={fill}
      />
      <circle cx="13" cy="13" r="12.35" stroke={fill} strokeWidth="1.3" />
    </svg>
  );
}

export function FillSettingIcon({ className, height }) {
  return (
    <svg
      className={className}
      width={height}
      height={height}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.5243 5.55411L11.2366 5.33928C11.143 4.95663 11.0065 4.59086 10.8288 4.2497L11.6532 3.22755C11.8285 3.01153 11.8205 2.70072 11.6357 2.49223L11.1235 1.91582C10.9379 1.70755 10.63 1.6635 10.3952 1.81187L9.29388 2.50416C8.8095 2.16573 8.26082 1.91582 7.66893 1.77081L7.45348 0.476139C7.40827 0.202001 7.17104 0.000854492 6.89256 0.000854492H6.12074C5.84283 0.000854492 5.6048 0.202001 5.5606 0.476139L5.34397 1.77121C4.85461 1.89103 4.39579 2.08442 3.97708 2.33914L2.92974 1.59169C2.70401 1.43042 2.39398 1.45564 2.197 1.6522L1.65172 2.19787C1.45516 2.39485 1.42995 2.70488 1.59163 2.9306L2.34082 3.97995C2.0885 4.3955 1.89709 4.85171 1.77729 5.33671L0.475256 5.55412C0.201538 5.59933 0 5.83657 0 6.11507V6.88628C0 7.16474 0.201538 7.40202 0.475256 7.44722L1.77729 7.66463C1.87568 8.06374 2.0185 8.44496 2.20833 8.79843L1.3877 9.81481C1.21296 10.0306 1.2203 10.3416 1.40515 10.5499L1.91692 11.1264C2.10259 11.335 2.41062 11.3783 2.64548 11.2303L3.76264 10.5285C4.23534 10.8518 4.77011 11.0895 5.34397 11.2303L5.5606 12.5252C5.60482 12.7993 5.84283 13.0005 6.12074 13.0005H6.89256C7.17104 13.0005 7.40827 12.7993 7.45348 12.5252L7.66929 11.2303C8.15254 11.1121 8.60554 10.9221 9.02053 10.6717L10.1115 11.4509C10.3368 11.6128 10.6471 11.5874 10.8439 11.3902L11.3894 10.8447C11.5857 10.6483 11.6123 10.3385 11.4492 10.1123L10.6725 9.02333C10.9256 8.60638 11.118 8.14936 11.237 7.6622L12.5248 7.44718C12.7993 7.40197 13 7.16471 13 6.88624V6.11502C12.9996 5.83657 12.7989 5.59933 12.5243 5.55411ZM6.52042 8.93811C5.17455 8.93811 4.08299 7.84634 4.08299 6.50067C4.08299 5.1548 5.17455 4.06324 6.52042 4.06324C7.86606 4.06324 8.95782 5.1548 8.95782 6.50067C8.95782 7.84634 7.86606 8.93811 6.52042 8.93811Z"
        fill="#2495E1"
      />
    </svg>
  );
}

export function FilterIcon({ className }) {
  return (
    <svg
      className={className}
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.7379 8.01789L12.9818 8.01789C13.5441 8.01789 14 7.56194 14 6.99973C14 6.43737 13.5441 5.98145 12.9818 5.98145L11.7379 5.98145C11.8799 6.29268 11.9637 6.6358 11.9637 6.99973C11.9637 7.36351 11.8799 7.70663 11.7379 8.01789Z"
        fill="#6D7F92"
      />
      <path
        d="M7.25 5.98145L1.01928 5.98145C0.456982 5.98145 0.00114582 6.4374 0.0011458 6.99973C0.00114577 7.56194 0.456982 8.01789 1.01928 8.01789L7.24974 8.01789C7.1078 7.70663 7.02399 7.36351 7.02399 6.99973C7.02399 6.6358 7.10806 6.29268 7.25 5.98145Z"
        fill="#6D7F92"
      />
      <path
        d="M10.9453 6.99968C10.9453 6.19925 10.2937 5.54785 9.49311 5.54785C8.69245 5.54785 8.04087 6.19925 8.04087 6.99968C8.04087 7.80052 8.69245 8.45224 9.49311 8.45224C10.2938 8.45227 10.9453 7.80052 10.9453 6.99968Z"
        fill="#6D7F92"
      />
      <path
        d="M1.64844 11.0723L1.01779 11.0723C0.455487 11.0723 -0.000348111 11.5282 -0.000348136 12.0904C-0.00034816 12.6528 0.455487 13.1085 1.01779 13.1085L1.64818 13.1085C1.50623 12.7975 1.42252 12.4544 1.42252 12.0904C1.42249 11.7264 1.5065 11.3835 1.64844 11.0723Z"
        fill="#6D7F92"
      />
      <path
        d="M6.13795 13.1085L12.9818 13.1085C13.5441 13.1085 14 12.6528 14 12.0904C14 11.5282 13.5441 11.0723 12.9818 11.0723L6.13795 11.0723C6.27983 11.3835 6.36364 11.7264 6.36364 12.0904C6.36364 12.4543 6.27983 12.7975 6.13795 13.1085Z"
        fill="#6D7F92"
      />
      <path
        d="M5.34375 12.0905C5.34375 11.2901 4.69229 10.6389 3.89154 10.6389C3.09088 10.6389 2.43931 11.2901 2.43931 12.0905C2.43931 12.8916 3.09088 13.5433 3.89154 13.5433C4.69229 13.5433 5.34375 12.8916 5.34375 12.0905Z"
        fill="#6D7F92"
      />
      <path
        d="M2.66797 0.890625L1.0191 0.890625C0.4568 0.890625 0.000966052 1.3464 0.000966028 1.90879C0.000966003 2.471 0.4568 2.92695 1.0191 2.92695L2.66771 2.92695C2.52574 2.61569 2.44193 2.27274 2.44193 1.90879C2.44193 1.54483 2.526 1.20188 2.66797 0.890625Z"
        fill="#6D7F92"
      />
      <path
        d="M7.15608 2.92671L12.9818 2.92671C13.5441 2.92671 14 2.47076 14 1.90854C14 1.34616 13.5441 0.890381 12.9818 0.890381L7.15608 0.890381C7.29802 1.20164 7.38183 1.54459 7.38183 1.90854C7.38183 2.2725 7.29802 2.61545 7.15608 2.92671Z"
        fill="#6D7F92"
      />
      <path
        d="M6.36328 1.90869C6.36328 1.10823 5.71171 0.457031 4.91104 0.457031C4.11041 0.457031 3.45884 1.10823 3.45884 1.90869C3.45884 2.7095 4.11041 3.36142 4.91104 3.36142C5.71171 3.36142 6.36328 2.70947 6.36328 1.90869Z"
        fill="#6D7F92"
      />
    </svg>
  );
}

export function UploadIcon({ className }) {
  return (
    <svg
      className={className}
      width="16"
      height="16"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.76523 3.2439H7.77302V4.4261H9.76523C10.3579 4.4261 10.8176 4.72855 10.8176 4.98903V10.2315C10.8176 10.4918 10.3579 10.7947 9.76523 10.7947H2.23437C1.64189 10.7947 1.18221 10.4918 1.18221 10.2315V4.98962C1.18221 4.72914 1.64189 4.4265 2.23437 4.4265H4.22639V3.24429H2.23437C0.981429 3.24429 0 4.01095 0 4.98962V10.2317C0 11.2106 0.981429 11.9769 2.23437 11.9769H9.76563C11.0182 11.9769 12 11.2102 12 10.2317V4.98962C11.9998 4.01056 11.0184 3.2439 9.76523 3.2439Z"
        fill="#18A0FB"
      />
      <path
        d="M7.78868 5.71469C7.63736 5.71469 7.48623 5.77262 7.37077 5.88808L6.63071 6.62794V4.06117V2.87897V0.614053C6.63071 0.287764 6.36609 0.0229492 6.0396 0.0229492C5.71312 0.0229492 5.4485 0.287764 5.4485 0.614053V2.87877V4.06098V6.66774L4.66844 5.88788C4.55298 5.77242 4.40165 5.71449 4.25053 5.71449C4.0994 5.71449 3.94808 5.77242 3.83262 5.88788C3.60169 6.11841 3.60169 6.49278 3.83262 6.72351L5.59746 8.48835C5.71292 8.60381 5.86424 8.66114 6.01517 8.66114C6.01675 8.66114 6.01832 8.66114 6.0197 8.66114C6.02108 8.66114 6.02266 8.66114 6.02404 8.66114C6.17536 8.66114 6.32629 8.60381 6.44175 8.48835L8.20659 6.72351C8.43751 6.49278 8.43751 6.11841 8.20659 5.88788C8.09113 5.77262 7.9402 5.71469 7.78868 5.71469Z"
        fill="#18A0FB"
      />
    </svg>
  );
}

export function CloudUploadIcon({ className }) {
  return (
    <svg
      className={className}
      width="44"
      height="44"
      viewBox="0 0 44 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M34.8877 16.7673C34.7959 10.059 29.3102 4.62964 22.5804 4.62964C19.5868 4.62964 16.7026 5.71864 14.4595 7.69605C12.4575 9.46078 11.088 11.8191 10.5456 14.4083C10.506 14.4078 10.4667 14.4075 10.4276 14.4075C4.67791 14.4075 0 19.0853 0 24.8351C0 30.5848 4.67791 35.2626 10.4276 35.2626H17.7102C18.2283 35.2626 18.6486 34.8425 18.6486 34.3243C18.6486 33.806 18.2283 33.3859 17.7102 33.3859H10.4276C5.7126 33.3859 1.8767 29.55 1.8767 24.8351C1.8767 20.1201 5.7126 16.2842 10.4276 16.2842C10.6788 16.2842 10.9444 16.2977 11.2396 16.3255C11.7399 16.3723 12.1891 16.0164 12.2572 15.518C12.5951 13.0413 13.818 10.7633 15.7005 9.10379C17.6007 7.4287 20.0439 6.50625 22.5803 6.50625C28.3325 6.50625 33.0121 11.186 33.0121 16.9381C33.0121 17.1452 32.9968 17.3587 32.9805 17.5847L32.9736 17.6808C32.954 17.9568 33.0573 18.2274 33.256 18.4202C33.4545 18.6129 33.7277 18.7082 34.0034 18.6806C34.253 18.6554 34.5048 18.6428 34.7518 18.6428C38.8163 18.6428 42.1233 21.9496 42.1233 26.0143C42.1233 30.0789 38.8164 33.3857 34.7518 33.3857H27.0938C26.5757 33.3857 26.1555 33.8058 26.1555 34.3241C26.1555 34.8424 26.5757 35.2624 27.0938 35.2624H34.7518C39.8512 35.2624 44 31.1138 44 26.0143C43.9999 20.9606 39.9248 16.8403 34.8877 16.7673Z"
        fill="#6D7F92"
      />
      <path
        d="M22.5811 9.03989C18.6574 9.03989 15.2986 11.9722 14.7682 15.8605C14.6982 16.374 15.0578 16.847 15.5712 16.9171C15.6142 16.9229 15.6569 16.9258 15.6991 16.9258C16.161 16.9258 16.5636 16.5847 16.6276 16.1142C17.0317 13.1511 19.5912 10.9166 22.5811 10.9166C23.0993 10.9166 23.5194 10.4965 23.5194 9.97824C23.5195 9.46003 23.0993 9.03989 22.5811 9.03989Z"
        fill="#6D7F92"
      />
      <path
        d="M26.8474 27.5045L23.4341 24.4554C22.8457 23.9295 21.958 23.9296 21.3693 24.4554L17.9561 27.5046C17.5695 27.8498 17.5362 28.443 17.8814 28.8296C18.2266 29.2159 18.8197 29.2495 19.2064 28.9042L21.4634 26.888V38.432C21.4634 38.9503 21.8835 39.3704 22.4018 39.3704C22.92 39.3704 23.3401 38.9503 23.3401 38.432V26.8878L25.5973 28.9042C25.7762 29.0641 25.9995 29.1427 26.222 29.1427C26.48 29.1427 26.7368 29.0371 26.9222 28.8295C27.2673 28.4429 27.2339 27.8498 26.8474 27.5045Z"
        fill="#6D7F92"
      />
    </svg>
  );
}

export function QuestionIcon({ className }) {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M11.5175 5.17673C10.741 4.91792 9.83522 5.17673 9.18813 5.69434C8.54104 6.21195 8.15283 6.98844 8.15283 7.89434C8.15283 8.28255 8.41164 8.54143 8.79992 8.54143C9.18813 8.54143 9.44701 8.28262 9.44701 7.89434C9.44701 7.50613 9.57641 6.98844 9.96462 6.72964C10.3528 6.47083 10.7411 6.34143 11.2587 6.47083C11.9058 6.60023 12.294 7.11792 12.4234 7.63553C12.5528 8.28262 12.4234 8.80023 11.9058 9.18852C10.8705 9.96501 10.3528 11.1297 10.3528 12.2944C10.3528 12.6826 10.6116 12.9415 10.9999 12.9415C11.3881 12.9415 11.647 12.6827 11.5175 12.2944C11.5175 11.5179 12.0351 10.7414 12.6822 10.2238C13.5881 9.44732 13.9763 8.41202 13.7175 7.37673C13.4587 6.21202 12.5528 5.43553 11.5175 5.17673Z" />
      <path d="M10.4824 15.659C10.353 15.7884 10.353 16.0472 10.353 16.1766C10.353 16.306 10.353 16.4354 10.4824 16.5648C10.6118 16.6942 10.8706 16.8236 11 16.8236C11.1294 16.8236 11.3882 16.6942 11.3882 16.5648C11.5177 16.5648 11.6471 16.306 11.6471 16.1766C11.6471 15.9178 11.5177 15.7884 11.3882 15.659C11.1294 15.4001 10.7412 15.4001 10.4824 15.659Z" />
      <path
        className="question-icon"
        d="M21.5 11C21.5 16.799 16.799 21.5 11 21.5C5.20101 21.5 0.5 16.799 0.5 11C0.5 5.20101 5.20101 0.5 11 0.5C16.799 0.5 21.5 5.20101 21.5 11Z"
      />
    </svg>
  );
}

export function ArchiveIcon({ className }) {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M25.9007 14.4449L23.6363 11.0484V6.50003C23.6363 6.34309 23.574 6.19301 23.4632 6.08222L17.5541 0.173118C17.4433 0.0623224 17.2933 0 17.1363 0H4.72725C3.42424 0 2.36365 1.06003 2.36365 2.36365V11.0484L0.0992726 14.4449C0.0346235 14.5419 0 14.6561 0 14.7727V23.6363C0 24.9399 1.06064 26 2.36365 26H23.6363C24.9394 26 26 24.94 26 23.6363V14.7727C25.9999 14.6561 25.9653 14.5419 25.9007 14.4449ZM23.6363 13.1789L24.3049 14.1818H23.6363V13.1789ZM17.7272 2.01742L21.6189 5.9091H18.909C18.257 5.9091 17.7272 5.37878 17.7272 4.7273V2.01742ZM3.54545 2.36365C3.54545 1.71218 4.07522 1.18185 4.72725 1.18185H16.5454V4.7273C16.5454 6.03086 17.606 7.09095 18.909 7.09095H22.4545V14.1819H21.2727C19.9697 14.1819 18.909 15.2419 18.909 16.5455C18.909 17.197 18.3793 17.7273 17.7272 17.7273H8.2727C7.62061 17.7272 7.0909 17.1969 7.0909 16.5455C7.0909 15.2418 6.03026 14.1818 4.72725 14.1818H3.54545V2.36365ZM2.36365 13.1789V14.1818H1.69506L2.36365 13.1789ZM24.8181 23.6363C24.8181 24.2878 24.2884 24.8181 23.6363 24.8181H2.36365C1.71157 24.8181 1.18185 24.2878 1.18185 23.6363V15.3636H4.7273C5.37939 15.3636 5.9091 15.8939 5.9091 16.5454C5.9091 17.849 6.96974 18.909 8.27275 18.909H17.7272C19.0303 18.909 20.0909 17.849 20.0909 16.5454C20.0909 15.8939 20.6207 15.3636 21.2727 15.3636H24.8181V23.6363Z"
        fill="#2495E1"
      />
    </svg>
  );
}

export function GarbageIcon({ className }) {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.8401 3.74178H18.4305V2.85979C18.4305 1.28289 17.1476 0 15.5707 0H10.4285C8.85156 0 7.56867 1.28289 7.56867 2.85979V3.74178H2.15913C1.75822 3.74178 1.4375 4.0625 1.4375 4.4634C1.4375 4.86431 1.75822 5.18503 2.15913 5.18503H3.4634V22.1406C3.4634 24.2681 5.19531 26 7.32278 26H18.6764C20.8039 26 22.5358 24.2681 22.5358 22.1406V5.18503H23.8401C24.241 5.18503 24.5617 4.86431 24.5617 4.4634C24.5617 4.0625 24.241 3.74178 23.8401 3.74178ZM9.01193 2.85979C9.01193 2.07936 9.64803 1.44326 10.4285 1.44326H15.5707C16.3512 1.44326 16.9873 2.07936 16.9873 2.85979V3.74178H9.01193V2.85979ZM21.0925 22.1406C21.0925 23.4716 20.0074 24.5567 18.6764 24.5567H7.32278C5.99178 24.5567 4.90666 23.4716 4.90666 22.1406V5.18503H21.0979V22.1406H21.0925Z"
        fill="#F4515D"
      />
      <path
        d="M12.999 21.9693C13.3999 21.9693 13.7206 21.6486 13.7206 21.2477V8.4936C13.7206 8.0927 13.3999 7.77197 12.999 7.77197C12.5981 7.77197 12.2773 8.0927 12.2773 8.4936V21.2424C12.2773 21.6433 12.5981 21.9693 12.999 21.9693Z"
        fill="#F4515D"
      />
      <path
        d="M8.29194 21.1728C8.69285 21.1728 9.01357 20.8521 9.01357 20.4511V9.28462C9.01357 8.88371 8.69285 8.56299 8.29194 8.56299C7.89104 8.56299 7.57031 8.88371 7.57031 9.28462V20.4511C7.57031 20.8521 7.89638 21.1728 8.29194 21.1728Z"
        fill="#F4515D"
      />
      <path
        d="M17.7099 21.1728C18.1108 21.1728 18.4315 20.8521 18.4315 20.4511V9.28462C18.4315 8.88371 18.1108 8.56299 17.7099 8.56299C17.309 8.56299 16.9883 8.88371 16.9883 9.28462V20.4511C16.9883 20.8521 17.309 21.1728 17.7099 21.1728Z"
        fill="#F4515D"
      />
    </svg>
  );
}

export function PenIcon({ className }) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      className={className}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.2671 1.73212C13.0275 0.489357 11.0117 0.489357 9.77216 1.73212L1.53098 9.97122C1.46655 10.0357 1.42666 10.1185 1.41439 10.2075L0.803814 14.7306C0.785405 14.8594 0.831428 14.9883 0.920406 15.0773C0.997111 15.154 1.1045 15.2 1.21188 15.2C1.23029 15.2 1.2487 15.2 1.26711 15.197L3.99167 14.8288C4.21872 14.7981 4.37827 14.5894 4.34758 14.3623C4.3169 14.1353 4.10826 13.9757 3.88122 14.0064L1.69666 14.301L2.12314 11.1465L5.44293 14.4667C5.51964 14.5434 5.62702 14.5894 5.73441 14.5894C5.8418 14.5894 5.94918 14.5464 6.02589 14.4667L14.2671 6.22757C14.8684 5.62613 15.1998 4.82831 15.1998 3.97831C15.1998 3.12832 14.8684 2.33049 14.2671 1.73212ZM9.93171 2.74475L11.3155 4.12867L3.79531 11.6497L2.41155 10.2658L9.93171 2.74475ZM5.73748 13.5891L4.3844 12.2358L11.9046 4.71477L13.2576 6.06801L5.73748 13.5891ZM13.8345 5.47577L10.5239 2.16479C10.9442 1.81804 11.4689 1.62779 12.0211 1.62779C12.6501 1.62779 13.2392 1.87328 13.6841 2.31515C14.129 2.75703 14.3714 3.34926 14.3714 3.97831C14.3714 4.53372 14.1812 5.05538 13.8345 5.47577Z"
        fill="#18A0FB"
      />
    </svg>
  );
}

export function ArrowRightIcon({ className }) {
  return (
    <svg
      width="15"
      height="15"
      className={className}
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0)">
        <path
          d="M10.1008 12.6148C9.89647 12.8263 9.55637 12.8263 9.34487 12.6148C9.14052 12.4105 9.14052 12.0704 9.34487 11.8665L13.178 8.03336L0.529216 8.03336C0.234361 8.03288 9.01344e-07 7.79852 9.54765e-07 7.50367C1.00819e-06 7.20881 0.234361 6.96683 0.529217 6.96683L13.178 6.96683L9.34487 3.14086C9.14052 2.92936 9.14052 2.58878 9.34487 2.3849C9.55637 2.17341 9.89695 2.17341 10.1008 2.3849L14.8414 7.12546C15.0529 7.32981 15.0529 7.66991 14.8414 7.87379L10.1008 12.6148Z"
          fill="#6D7F92"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect
            width="15"
            height="15"
            transform="matrix(1 1.68735e-07 1.81178e-07 -1 0 15)"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export function ArrowLeftIcon({ className }) {
  return (
    <svg
      width="14"
      height="13"
      viewBox="0 0 14 13"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.259444 6.71442L5.55299 11.9383C5.89429 12.2761 6.44627 12.2717 6.78408 11.9296C7.1219 11.5874 7.11842 11.0363 6.77536 10.6985L2.99241 6.96518L13.1294 6.96518C13.6108 6.96518 14 6.57601 14 6.09455C14 5.61309 13.6108 5.22388 13.1294 5.22388L2.99241 5.22388L6.77536 1.49056C7.11838 1.15274 7.121 0.601627 6.78408 0.259469C6.61345 0.0870787 6.38881 2.45072e-05 6.16418 2.45269e-05C5.94302 2.45462e-05 5.7219 0.0835979 5.55299 0.250788L0.259444 5.47468C0.0940155 5.63835 -5.53185e-07 5.86127 -5.32787e-07 6.09459C-5.12397e-07 6.32783 0.0931554 6.54985 0.259444 6.71442Z"
        fill="#6D7F92"
      />
    </svg>
  );
}

export function RefreshIcon({ className }) {
  return (
    <svg
      className={className}
      width="14"
      height="14"
      viewBox="0 0 16 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.8573 7.27148C14.5417 7.27148 14.2858 7.49585 14.2858 7.77262C14.2851 10.817 11.4704 13.2846 7.99885 13.2839C6.23578 13.2836 4.55394 12.634 3.36352 11.4935L5.89494 10.7533C6.19473 10.6659 6.35696 10.3818 6.25721 10.1189C6.15747 9.85602 5.8336 9.71375 5.5338 9.80122L2.10523 10.8035C1.87119 10.8718 1.71359 11.0642 1.71436 11.2805V14.2873C1.71436 14.5641 1.9702 14.7884 2.2858 14.7884C2.6014 14.7884 2.85724 14.5641 2.85724 14.2873V12.4567C5.79918 14.9545 10.493 14.8879 13.3412 12.3079C14.6835 11.092 15.4324 9.46499 15.4286 7.77262C15.4287 7.49585 15.1729 7.27148 14.8573 7.27148Z"
        fill="#3C4E64"
      />
      <path
        d="M13.7141 0.756836C13.3985 0.756836 13.1427 0.981199 13.1427 1.25797V3.08858C10.2008 0.590759 5.50694 0.657413 2.65871 3.23739C1.31641 4.45329 0.567586 6.08026 0.571303 7.77263C0.571303 8.04941 0.82714 8.27377 1.14274 8.27377C1.45834 8.27377 1.71415 8.04941 1.71415 7.77263C1.71485 4.72821 4.52959 2.26069 8.00112 2.26131C9.76419 2.2616 11.446 2.91126 12.6365 4.05175L10.105 4.7919C9.80524 4.87938 9.64302 5.1634 9.74276 5.42632C9.8425 5.68924 10.1664 5.8315 10.4662 5.74403L13.8947 4.74178C14.1288 4.67342 14.2864 4.48104 14.2856 4.26472V1.25795C14.2856 0.981199 14.0297 0.756836 13.7141 0.756836Z"
        fill="#3C4E64"
      />
    </svg>
  );
}

export function SimpleArrowUp({ className }) {
  return (
    <svg
      className={className}
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path
          d="M5.57169 2.87196L0.177143 8.26831C-0.0590474 8.5051 -0.0590474 8.88873 0.177143 9.12612C0.413333 9.36291 0.796967 9.36291 1.03316 9.12612L5.99968 4.15781L10.9662 9.12552C11.2024 9.36231 11.586 9.36231 11.8228 9.12552C12.059 8.88874 12.059 8.5045 11.8228 8.26771L6.42826 2.87137C6.19451 2.63817 5.80484 2.63817 5.57169 2.87196Z"
          fill="#18A0FB"
        />
      </g>
    </svg>
  );
}

export function SimpleArrowRight({ className }) {
  return (
    <svg
      className={className}
      width="12"
      height="12"
      viewBox="0 0 6 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.08538 3.71446L1.48781 0.118095C1.32995 -0.039365 1.0742 -0.039365 0.91594 0.118095C0.758082 0.275555 0.758082 0.531311 0.91594 0.688771L4.22815 3.99978L0.916339 7.3108C0.75848 7.46826 0.75848 7.72401 0.916339 7.88187C1.0742 8.03933 1.33035 8.03933 1.48821 7.88187L5.08578 4.2855C5.24124 4.12967 5.24124 3.8699 5.08538 3.71446Z"
        fill="#29394D"
      />
    </svg>
  );
}

export function CycleIcon({ className }) {
  return (
    <svg
      className={className}
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.2847 8.80493H4.28273C3.88769 8.80493 3.56744 9.12517 3.56744 9.52021C3.56744 9.91525 3.88769 10.2355 4.28273 10.2355H11.2847C11.6797 10.2355 12 9.91525 12 9.52021C12 9.12517 11.6797 8.80493 11.2847 8.80493Z"
        fill="#29394D"
      />
      <path
        d="M9.33908 5.09473H2.33711C1.94207 5.09473 1.62183 5.41497 1.62183 5.81001C1.62183 6.20505 1.94207 6.52529 2.33711 6.52529H9.33908C9.73411 6.52529 10.0544 6.20505 10.0544 5.81001C10.0544 5.41497 9.73411 5.09473 9.33908 5.09473Z"
        fill="#29394D"
      />
      <path
        d="M7.71725 1.38452H0.715282C0.320243 1.38452 0 1.70476 0 2.0998C0 2.49484 0.320243 2.81508 0.715282 2.81508H7.71725C8.11229 2.81508 8.43253 2.49484 8.43253 2.0998C8.43253 1.70476 8.11229 1.38452 7.71725 1.38452Z"
        fill="#29394D"
      />
    </svg>
  );
}

export function DoubleArrowUp({ className, fill }) {
  return (
    <svg
      width="11"
      height="14"
      viewBox="0 0 11 14"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0)">
        <path
          d="M5.0558 2.60519L0.16074 7.50188C-0.0535801 7.71674 -0.0535801 8.06485 0.16074 8.28026C0.375061 8.49512 0.723174 8.49512 0.937494 8.28026L5.44415 3.77197L9.95081 8.27972C10.1651 8.49458 10.5132 8.49458 10.7281 8.27972C10.9424 8.06485 10.9424 7.7162 10.7281 7.50133L5.83305 2.60465C5.62094 2.39304 5.26736 2.39304 5.0558 2.60519Z"
          fill={fill ? fill : "#6D7F92"}
        />
      </g>
      <g opacity="0.6">
        <g clipPath="url(#clip1)">
          <path
            d="M5.16695 8.08323L1.67048 11.5809C1.51739 11.7343 1.51739 11.983 1.67048 12.1368C1.82356 12.2903 2.07222 12.2903 2.2253 12.1368L5.44434 8.91664L8.66338 12.1365C8.81647 12.2899 9.06512 12.2899 9.2186 12.1365C9.37168 11.983 9.37168 11.7339 9.2186 11.5805L5.72213 8.08284C5.57062 7.93169 5.31806 7.93169 5.16695 8.08323Z"
            fill={fill ? fill : "#6D7F92"}
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0">
          <rect
            width="10.8889"
            height="10.8889"
            fill="white"
            transform="translate(0 10.8887) rotate(-90)"
          />
        </clipPath>
        <clipPath id="clip1">
          <rect
            width="7.77778"
            height="7.77778"
            fill="white"
            transform="translate(1.55566 14) rotate(-90)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export function CloseIcon({ className, dimension }) {
  return (
    <svg
      width={dimension}
      height={dimension}
      viewBox="0 0 17 17"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.47907 8.49955L0.41794 2.43842C-0.139994 1.88049 -0.139994 0.975897 0.41794 0.418042C0.975876 -0.139892 1.88038 -0.139892 2.43832 0.418042L8.49953 6.47925L14.5607 0.417963C15.1187 -0.139972 16.0232 -0.139972 16.5811 0.417963C17.139 0.975897 17.139 1.88049 16.5811 2.43834L10.5199 8.49947L16.5811 14.5607C17.139 15.1186 17.139 16.0232 16.5811 16.5811C16.0232 17.139 15.1187 17.139 14.5607 16.5811L8.49953 10.5198L2.43832 16.5811C1.88046 17.139 0.975876 17.139 0.41794 16.5811C-0.139994 16.0231 -0.139994 15.1186 0.41794 14.5607L6.47907 8.49955Z"
        fill="#3C4E64"
      />
    </svg>
  );
}

export function CloseIconCircle({ className }) {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.8118 13.0706L8.24661 9.50538C7.91843 9.1772 7.91843 8.64512 8.24661 8.31698C8.57479 7.9888 9.10683 7.9888 9.43501 8.31698L13.0003 11.8822L16.5655 8.31694C16.8937 7.98876 17.4257 7.98876 17.7539 8.31694C18.082 8.64512 18.082 9.1772 17.7539 9.50534L14.1887 13.0705L17.7539 16.6358C18.082 16.964 18.082 17.496 17.7539 17.8242C17.4257 18.1524 16.8937 18.1524 16.5655 17.8242L13.0003 14.2589L9.43501 17.8242C9.10688 18.1524 8.57479 18.1524 8.24661 17.8242C7.91843 17.496 7.91843 16.964 8.24661 16.6358L11.8118 13.0706Z"
      />
      <circle cx="13" cy="13" r="12.35" strokeWidth="1.3" />
    </svg>
  );
}

export function CheckAuthorisationIcon({ className }) {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path d="M11.258 18.9999C10.885 18.9999 10.5322 18.8254 10.3054 18.5261L7.24231 14.4809C6.84391 13.9548 6.94762 13.2056 7.47374 12.8071C8.00071 12.4083 8.74934 12.5127 9.14791 13.0385L11.1625 15.6987L16.2295 7.56306C16.5783 7.00334 17.3149 6.83209 17.8759 7.18043C18.4361 7.52912 18.6072 8.26626 18.2581 8.82649L12.2725 18.4368C12.0646 18.7709 11.7056 18.9811 11.3125 18.9989C11.2942 18.9996 11.2762 18.9999 11.258 18.9999Z" />
      <circle cx="13" cy="13" r="12.35" strokeWidth="1.3" />
    </svg>
  );
}

export function SettingIconEmpty({ className }) {
  return (
    <svg
      className={className}
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M24.6692 15.7284L22.8442 16.0379C22.6541 16.6517 22.4097 17.2437 22.111 17.8086L23.1864 19.313C23.6426 19.9539 23.572 20.8284 23.0126 21.3824L21.3941 23.0009C21.0899 23.3051 20.688 23.4734 20.2589 23.4734C19.9222 23.4734 19.6017 23.3703 19.3302 23.1747L17.8202 22.0993C17.2337 22.4089 16.6199 22.6642 15.9844 22.8543L15.6803 24.6575C15.5499 25.4342 14.8819 25.999 14.0943 25.999H11.8077C11.0202 25.999 10.3521 25.4342 10.2218 24.6575L9.90677 22.8108C9.29846 22.6207 8.70644 22.3709 8.14158 22.0667L6.64796 23.1421C6.3764 23.3377 6.05052 23.4409 5.71377 23.4409C5.2847 23.4409 4.87735 23.2725 4.57862 22.9683L2.95465 21.3498C2.40065 20.7958 2.32462 19.9214 2.78085 19.2805L3.86712 17.7542C3.56839 17.184 3.32941 16.5919 3.14475 15.9782L1.34154 15.674C0.56486 15.5437 0 14.8756 0 14.0881V11.8015C0 11.0139 0.56486 10.3459 1.34154 10.2155L3.1882 9.90052C3.3783 9.29221 3.62814 8.7002 3.93229 8.13534L2.86232 6.64715C2.40609 6.00625 2.47669 5.13181 3.03612 4.57781L4.65466 2.95927C4.95882 2.65512 5.36074 2.48674 5.78981 2.48674C6.12655 2.48674 6.447 2.58994 6.71857 2.78547L8.24478 3.87173C8.79334 3.58387 9.36907 3.35032 9.96108 3.16566L10.2652 1.34073C10.3956 0.564047 11.0636 -0.000812531 11.8512 -0.000812531H14.1432C14.9308 -0.000812531 15.5988 0.564047 15.7292 1.34073L16.0388 3.16566C16.6525 3.35576 17.2445 3.60017 17.8094 3.89889L19.3139 2.82349C19.5854 2.62796 19.9113 2.52476 20.248 2.52476C20.6771 2.52476 21.079 2.69313 21.3832 2.99729L23.0017 4.61583C23.5557 5.16983 23.6318 6.04427 23.1755 6.68517L22.1001 8.19508C22.3989 8.76538 22.6487 9.35739 22.8334 9.9657L24.6583 10.2699C25.435 10.4002 25.9998 11.0683 25.9998 11.8558V14.1424C26.0107 14.9299 25.4458 15.598 24.6692 15.7284ZM24.5442 11.8558C24.5442 11.7852 24.4954 11.7255 24.4248 11.7146L22.1436 11.3344C21.8557 11.2855 21.6276 11.0737 21.557 10.7967C21.3506 9.99829 21.0356 9.23247 20.6119 8.52096C20.4653 8.27112 20.4762 7.96153 20.6445 7.72256L21.9861 5.83245C22.0241 5.77814 22.0187 5.69667 21.9698 5.64778L20.3512 4.02924C20.3132 3.99122 20.2752 3.98579 20.248 3.98579C20.2155 3.98579 20.1883 3.99666 20.1666 4.01295L18.2819 5.35449C18.0484 5.52286 17.7333 5.53373 17.4835 5.38708C16.772 4.96343 16.0062 4.64842 15.2078 4.44203C14.9253 4.37142 14.7135 4.13787 14.6701 3.85544L14.2844 1.57428C14.2736 1.50367 14.2138 1.45479 14.1432 1.45479H11.8566C11.786 1.45479 11.7263 1.50367 11.7154 1.57428L11.3352 3.85544C11.2863 4.1433 11.0745 4.37142 10.7975 4.44203C10.0208 4.64298 9.2713 4.95257 8.57066 5.35449C8.4566 5.41967 8.32625 5.45226 8.20133 5.45226C8.05468 5.45226 7.9026 5.4088 7.77768 5.31647L5.87671 3.96407C5.84956 3.94777 5.8224 3.93691 5.79524 3.93691C5.77352 3.93691 5.73007 3.94234 5.69205 3.98036L4.07351 5.5989C4.02463 5.64778 4.01919 5.72382 4.05721 5.78357L5.39332 7.65738C5.5617 7.89636 5.57256 8.21138 5.42591 8.46122C5.00227 9.16729 4.67639 9.93311 4.47 10.7315C4.39396 11.0085 4.16584 11.2203 3.88341 11.2692L1.58595 11.6603C1.51534 11.6711 1.46646 11.7309 1.46646 11.8015V14.0881C1.46646 14.1587 1.51534 14.2184 1.58595 14.2293L3.85082 14.6095C4.13868 14.6584 4.37223 14.8702 4.44284 15.1526C4.6438 15.951 4.95339 16.7223 5.3716 17.4338C5.51824 17.6836 5.50195 17.9932 5.33358 18.2268L3.98117 20.1277C3.94316 20.1821 3.94859 20.2635 3.99747 20.3124L5.61601 21.9309C5.65403 21.969 5.69205 21.9744 5.7192 21.9744C5.75179 21.9744 5.77895 21.9635 5.80067 21.9472L7.67449 20.6111C7.91347 20.4428 8.22849 20.4319 8.47833 20.5785C9.1844 21.0022 9.95022 21.3281 10.7486 21.5345C11.0256 21.6105 11.2374 21.8386 11.2863 22.121L11.6774 24.4185C11.6883 24.4891 11.748 24.538 11.8186 24.538H14.1052C14.1758 24.538 14.2355 24.4891 14.2464 24.4185L14.6266 22.1536C14.6755 21.8658 14.8873 21.6322 15.1697 21.5616C15.9899 21.3552 16.772 21.0348 17.4998 20.6057C17.7496 20.4591 18.0592 20.4699 18.2982 20.6383L20.172 21.9853C20.1992 22.0016 20.2263 22.0124 20.2535 22.0124C20.2752 22.0124 20.3187 22.007 20.3567 21.969L21.9752 20.3504C22.0241 20.3015 22.0295 20.2255 21.9915 20.1658L20.65 18.2811C20.4816 18.0475 20.4707 17.7325 20.6174 17.4827C21.041 16.7712 21.356 16.0054 21.5624 15.2069C21.633 14.9245 21.8666 14.7127 22.149 14.6692L24.4302 14.2836C24.5008 14.2728 24.5497 14.213 24.5497 14.1424V11.8558H24.5442Z" />
      <path d="M13.0032 18.6133C9.90729 18.6133 7.39258 16.0986 7.39258 13.0027C7.39258 9.90684 9.90729 7.39213 13.0032 7.39213C16.099 7.39213 18.6137 9.90684 18.6137 13.0027C18.6137 16.0986 16.099 18.6133 13.0032 18.6133ZM13.0032 8.85859C10.7166 8.85859 8.85904 10.7161 8.85904 13.0027C8.85904 15.2893 10.7166 17.1468 13.0032 17.1468C15.2897 17.1468 17.1473 15.2893 17.1473 13.0027C17.1473 10.7161 15.2897 8.85859 13.0032 8.85859Z" />
    </svg>
  );
}

export function StatisticsIcon({ className }) {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 20 20"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.5275 17.8362H0.4725C0.211523 17.8362 0 18.0477 0 18.3087C0 18.5696 0.211523 18.7812 0.4725 18.7812H19.5275C19.7884 18.7812 20 18.5696 20 18.3087C20 18.0477 19.7885 17.8362 19.5275 17.8362Z"
        fill="#29394D"
      />
      <path
        d="M18.2957 3.4495H14.9774C14.7165 3.4495 14.5049 3.6611 14.5049 3.922V7.1345H12.1316V1.69137C12.1316 1.43047 11.92 1.21887 11.6591 1.21887H8.34073C8.07983 1.21887 7.86823 1.43047 7.86823 1.69137V10.6321H5.49491V6.61571C5.49491 6.35473 5.28331 6.14321 5.02241 6.14321H1.70413C1.44315 6.14321 1.23163 6.35473 1.23163 6.61571V15.6611C1.23163 15.9221 1.44323 16.1336 1.70413 16.1336H5.02241H8.34069H11.659H14.9774H18.2957C18.5566 16.1336 18.7682 15.922 18.7682 15.6611V3.922C18.7682 3.6611 18.5567 3.4495 18.2957 3.4495ZM4.54995 15.1886H2.17663V7.08821H4.54995V15.1886ZM7.86831 15.1886H5.49499V11.5771H7.86831V15.1886ZM11.1866 7.607V15.1886H8.81327V2.16387H11.1866V7.607ZM14.505 15.1886H12.1317V8.0795H14.505V15.1886ZM17.8233 15.1886H15.45V7.607V4.3945H17.8233V15.1886H17.8233Z"
        fill="#29394D"
      />
    </svg>
  );
}

export function VerticalLineIcon({ className }) {
  return (
    <svg
      width="7"
      height="16"
      viewBox="0 0 7 16"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="6" width="1" height="16" rx="0.5" fill="#B6BFC8" />
      <rect x="3" width="1" height="16" rx="0.5" fill="#B6BFC8" />
      <rect width="1" height="16" rx="0.5" fill="#B6BFC8" />
    </svg>
  );
}

export function PelletGoIcon({ className }) {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0)">
        <path
          d="M11.4542 0H7.09053C6.78929 0 6.54507 0.244219 6.54507 0.545461C6.54507 0.846703 6.78929 1.09092 7.09053 1.09092H10.1373L4.52305 6.70524C4.31003 6.91826 4.31003 7.26359 4.52305 7.47661C4.62953 7.58311 4.76912 7.63636 4.90871 7.63636C5.04831 7.63636 5.18792 7.58313 5.29442 7.47659L10.9087 1.8623V4.9091C10.9087 5.21034 11.153 5.45456 11.4542 5.45456C11.7554 5.45456 11.9997 5.21034 11.9997 4.9091V0.545461C11.9996 0.244219 11.7554 0 11.4542 0Z"
          fill="#29394D"
        />
        <path
          d="M9.27272 5.45485C8.97148 5.45485 8.72726 5.69907 8.72726 6.00031V10.9094H1.0909V3.27303H6C6.30124 3.27303 6.54546 3.02881 6.54546 2.72757C6.54546 2.42632 6.30124 2.18213 6 2.18213H0.545461C0.244219 2.18213 0 2.42635 0 2.72759V11.4549C0 11.7561 0.244219 12.0003 0.545461 12.0003H9.27274C9.57398 12.0003 9.8182 11.7561 9.8182 11.4548V6.00031C9.81818 5.69907 9.57396 5.45485 9.27272 5.45485Z"
          fill="#29394D"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="12" height="12" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function AddIcon({ className }) {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.1592 12.1597L12.1592 7.11772C12.1592 6.6536 12.5355 6.27736 12.9995 6.27739C13.4637 6.27739 13.8399 6.6536 13.8399 7.11771L13.8399 12.1597L18.8819 12.1597C19.346 12.1597 19.7222 12.5359 19.7222 13C19.7222 13.4641 19.346 13.8404 18.8819 13.8404L13.8399 13.8403L13.8399 18.8823C13.8399 19.3464 13.4637 19.7227 12.9996 19.7227C12.5355 19.7227 12.1593 19.3465 12.1593 18.8823L12.1593 13.8403L7.11727 13.8403C6.65318 13.8404 6.27694 13.4641 6.27694 13C6.27694 12.5359 6.65315 12.1597 7.11727 12.1597L12.1592 12.1597Z"
      />
      <circle cx="13" cy="13" r="12.35" strokeWidth="1.3" />
    </svg>
  );
}
export function Garbage({ className }) {
  return (
    <svg
      className={className}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.671 2.30263H11.342V1.75987C11.342 0.789474 10.5525 0 9.58213 0H6.41766C5.44727 0 4.65779 0.789474 4.65779 1.75987V2.30263H1.32884C1.08213 2.30263 0.884766 2.5 0.884766 2.74671C0.884766 2.99342 1.08213 3.19079 1.32884 3.19079H2.13148V13.625C2.13148 14.9342 3.19727 16 4.50648 16H11.4933C12.8025 16 13.8683 14.9342 13.8683 13.625V3.19079H14.671C14.9177 3.19079 15.115 2.99342 15.115 2.74671C15.115 2.5 14.9177 2.30263 14.671 2.30263ZM5.54595 1.75987C5.54595 1.27961 5.9374 0.888158 6.41766 0.888158H9.58213C10.0624 0.888158 10.4538 1.27961 10.4538 1.75987V2.30263H5.54595V1.75987ZM12.9802 13.625C12.9802 14.4441 12.3124 15.1118 11.4933 15.1118H4.50648C3.6874 15.1118 3.01963 14.4441 3.01963 13.625V3.19079H12.9835V13.625H12.9802Z"
        fill={"red"}
      />
      <path
        d="M7.99876 13.52C8.24547 13.52 8.44283 13.3227 8.44283 13.076V5.22728C8.44283 4.98057 8.24547 4.7832 7.99876 4.7832C7.75205 4.7832 7.55469 4.98057 7.55469 5.22728V13.0727C7.55469 13.3194 7.75205 13.52 7.99876 13.52Z"
        fill={"red"}
      />
      <path
        d="M5.10228 13.0294C5.34899 13.0294 5.54636 12.832 5.54636 12.5853V5.71361C5.54636 5.4669 5.34899 5.26953 5.10228 5.26953C4.85557 5.26953 4.6582 5.4669 4.6582 5.71361V12.5853C4.6582 12.832 4.85886 13.0294 5.10228 13.0294Z"
        fill={"red"}
      />
      <path
        d="M10.8972 13.0294C11.1439 13.0294 11.3413 12.832 11.3413 12.5853V5.71361C11.3413 5.4669 11.1439 5.26953 10.8972 5.26953C10.6505 5.26953 10.4531 5.4669 10.4531 5.71361V12.5853C10.4531 12.832 10.6505 13.0294 10.8972 13.0294Z"
        fill={"red"}
      />
    </svg>
  );
}

export function OpenEye({ className }) {
  return (
    <svg
      className={className}
      width="16"
      height="11"
      viewBox="0 0 16 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.8215 4.52681C14.988 3.16372 13.8674 2.06848 12.4598 1.24113C11.052 0.41374 9.56549 0 8 0C6.43451 0 4.94793 0.413583 3.54018 1.24113C2.1324 2.06848 1.01183 3.16372 0.178505 4.52681C0.0595122 4.73511 0 4.94048 0 5.14291C0 5.34534 0.0595122 5.55071 0.178505 5.75896C1.01183 7.12211 2.1324 8.21744 3.54018 9.0446C4.94793 9.87208 6.43451 10.2855 8 10.2855C9.56552 10.2855 11.052 9.87346 12.4598 9.04911C13.8674 8.22472 14.9882 7.12796 15.8215 5.75896C15.9405 5.55071 16 5.34543 16 5.14291C16 4.94048 15.9405 4.73511 15.8215 4.52681ZM6.08469 2.0848C6.6174 1.5521 7.25577 1.28566 7.99991 1.28566C8.1189 1.28566 8.22016 1.32744 8.30353 1.41072C8.38678 1.49403 8.42863 1.59526 8.42863 1.71428C8.42863 1.8334 8.38678 1.93457 8.30372 2.01775C8.22047 2.10116 8.11915 2.14281 8.00012 2.14281C7.48825 2.14281 7.05062 2.32445 6.68757 2.68746C6.3244 3.0507 6.14292 3.48814 6.14292 4.00001C6.14292 4.1192 6.10114 4.2203 6.01786 4.30367C5.93446 4.38711 5.83332 4.42873 5.7143 4.42873C5.59518 4.42873 5.49401 4.38702 5.41064 4.30367C5.32724 4.2203 5.28558 4.11907 5.28558 4.00001C5.28558 3.25603 5.55202 2.61754 6.08469 2.0848ZM11.8795 8.05823C10.686 8.78126 9.39289 9.14299 8 9.14299C6.60714 9.14299 5.31401 8.78148 4.12057 8.05823C2.92714 7.33498 1.93457 6.36324 1.14293 5.14291C2.04768 3.7381 3.18161 2.68743 4.54469 1.99114C4.18162 2.61009 4.00002 3.2798 4.00002 3.99998C4.00002 5.10129 4.39146 6.04301 5.17412 6.82586C5.95679 7.60871 6.89885 7.99997 8 7.99997C9.10124 7.99997 10.043 7.60849 10.8259 6.82586C11.6087 6.04323 12 5.10129 12 3.99998C12 3.2798 11.8184 2.61 11.4553 1.99114C12.8183 2.68743 13.9523 3.7382 14.857 5.14291C14.0655 6.36324 13.073 7.33498 11.8795 8.05823Z"
        fill="#18A0FB"
      />
    </svg>
  );
}
export function CloseEye({ className }) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0)">
        <path
          d="M11.2946 9.12084C11.7648 8.43921 12.0001 7.68473 12.0001 6.85747C12.0001 6.62536 11.9763 6.37534 11.9286 6.10742L9.42871 10.5895C10.2023 10.292 10.8244 9.80214 11.2946 9.12084Z"
          fill="white"
        />
        <path
          d="M11.6608 2.9462C11.6667 2.93438 11.6695 2.90758 11.6695 2.86589C11.6695 2.76466 11.6219 2.68445 11.5266 2.62462C11.5088 2.61274 11.4508 2.5785 11.3524 2.52183C11.2543 2.46538 11.1604 2.41028 11.0713 2.35665C10.9821 2.30308 10.884 2.24807 10.7767 2.19153C10.6695 2.13495 10.5773 2.08883 10.5 2.05308C10.4225 2.0174 10.369 1.99951 10.3393 1.99951C10.2321 1.99951 10.1488 2.0472 10.0893 2.1424L9.60727 3.00853C9.06575 2.90739 8.52989 2.85673 8.00012 2.85673C6.39892 2.85673 4.92275 3.26159 3.57148 4.07108C2.22031 4.8807 1.08942 5.98479 0.178599 7.38359C0.0595122 7.56826 0 7.77362 0 7.99982C0 8.22595 0.0595122 8.43142 0.178599 8.61583C0.702357 9.43121 1.32293 10.1606 2.04021 10.8033C2.75748 11.4463 3.54165 11.961 4.39283 12.3481C4.13092 12.7944 3.99998 13.0535 3.99998 13.125C3.99998 13.2321 4.04764 13.3153 4.1429 13.3748C4.86903 13.7917 5.26779 13.9998 5.33927 13.9998C5.44629 13.9998 5.5297 13.952 5.58921 13.8567L6.02671 13.0622C6.65771 11.9374 7.59811 10.2498 8.84821 7.99985C10.0983 5.74981 11.0357 4.06527 11.6608 2.9462ZM4.95537 11.3481C3.4078 10.6517 2.13687 9.53566 1.14293 7.99991C2.04768 6.59511 3.18161 5.54444 4.54469 4.84815C4.18162 5.4671 4.00002 6.13678 4.00002 6.85702C4.00002 7.49389 4.14578 8.09792 4.43752 8.66943C4.7292 9.24091 5.13397 9.71394 5.65185 10.089L4.95537 11.3481ZM8.30372 4.87467C8.22047 4.95807 8.11902 4.99973 8 4.99973C7.48813 4.99973 7.05052 5.18136 6.68745 5.54438C6.32428 5.90761 6.1428 6.34505 6.1428 6.85692C6.1428 6.97611 6.10102 7.07721 6.01774 7.16058C5.9343 7.24399 5.83317 7.28564 5.71417 7.28564C5.59506 7.28564 5.49386 7.24393 5.41051 7.16058C5.32711 7.07721 5.28545 6.97598 5.28545 6.85692C5.28545 6.11295 5.5519 5.47448 6.08457 4.94172C6.61727 4.40902 7.25564 4.1426 7.99975 4.1426C8.11877 4.1426 8.22 4.18438 8.3035 4.26766C8.38675 4.35097 8.42847 4.4522 8.42847 4.57123C8.4285 4.69032 8.38678 4.79151 8.30372 4.87467Z"
          fill="white"
        />
        <path
          d="M15.8214 7.38339C15.482 6.81798 15.052 6.27027 14.5312 5.74051C14.0107 5.21078 13.4673 4.75554 12.9017 4.37451L12.3392 5.37452C13.3333 6.05902 14.1726 6.9341 14.857 7.99953C14.137 9.11853 13.2395 10.0323 12.1654 10.7405C11.0909 11.4492 9.92272 11.8567 8.66077 11.9638L8 13.1424C9.3215 13.1424 10.57 12.8597 11.7455 12.2942C12.9211 11.7289 13.9555 10.9342 14.8483 9.91045C15.2649 9.42819 15.5893 8.99669 15.8215 8.61573C15.9406 8.4132 16 8.20774 16 7.99959C16 7.79128 15.9405 7.58591 15.8214 7.38339Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
export function ChartDesactive({ className }) {
  return (
    <svg
      width="14"
      height="16"
      viewBox="0 0 14 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0)">
        <path
          d="M13.6692 14.2686H0.33075C0.148066 14.2686 0 14.4378 0 14.6466C0 14.8553 0.148066 15.0246 0.33075 15.0246H13.6692C13.8519 15.0246 14 14.8553 14 14.6466C14 14.4378 13.8519 14.2686 13.6692 14.2686Z"
          fill="#EEF6FF"
        />
        <path
          d="M13.9448 3.7845H11.622C11.4394 3.7845 11.2913 3.95378 11.2913 4.1625V6.7325H9.62997V2.378C9.62997 2.16928 9.48185 2 9.29922 2H6.97637C6.79374 2 6.64562 2.16928 6.64562 2.378V9.53056H4.9843V6.31747C4.9843 6.10869 4.83618 5.93947 4.65355 5.93947H2.33075C2.14807 5.93947 2 6.10869 2 6.31747V13.5538C2 13.7626 2.14812 13.9318 2.33075 13.9318H4.65355H6.97634H9.29919H11.622H13.9448C14.1275 13.9318 14.2756 13.7625 14.2756 13.5538V4.1625C14.2756 3.95378 14.1275 3.7845 13.9448 3.7845ZM4.32282 13.1758H2.6615V6.69547H4.32282V13.1758ZM6.64568 13.1758H4.98435V10.2866H6.64568V13.1758ZM8.9685 7.1105V13.1758H7.30715V2.756H8.9685V7.1105ZM11.2914 13.1758H9.63003V7.4885H11.2914V13.1758ZM13.6141 13.1758H11.9529V7.1105V4.5405H13.6142V13.1758H13.6141Z"
          fill="#29394D"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="14" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
export function ChartActive({ className }) {
  return (
    <svg
      width="14"
      height="16"
      viewBox="0 0 14 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0)">
        <path
          d="M13.6692 14.2686H0.33075C0.148066 14.2686 0 14.4378 0 14.6466C0 14.8553 0.148066 15.0246 0.33075 15.0246H13.6692C13.8519 15.0246 14 14.8553 14 14.6466C14 14.4378 13.8519 14.2686 13.6692 14.2686Z"
          fill="#EEF6FF"
        />
        <path
          d="M13.9448 3.7845H11.622C11.4394 3.7845 11.2913 3.95378 11.2913 4.1625V6.7325H9.62997V2.378C9.62997 2.16928 9.48185 2 9.29922 2H6.97637C6.79374 2 6.64562 2.16928 6.64562 2.378V9.53056H4.9843V6.31747C4.9843 6.10869 4.83618 5.93947 4.65355 5.93947H2.33075C2.14807 5.93947 2 6.10869 2 6.31747V13.5538C2 13.7626 2.14812 13.9318 2.33075 13.9318H4.65355H6.97634H9.29919H11.622H13.9448C14.1275 13.9318 14.2756 13.7625 14.2756 13.5538V4.1625C14.2756 3.95378 14.1275 3.7845 13.9448 3.7845ZM4.32282 13.1758H2.6615V6.69547H4.32282V13.1758ZM6.64568 13.1758H4.98435V10.2866H6.64568V13.1758ZM8.9685 7.1105V13.1758H7.30715V2.756H8.9685V7.1105ZM11.2914 13.1758H9.63003V7.4885H11.2914V13.1758ZM13.6141 13.1758H11.9529V7.1105V4.5405H13.6142V13.1758H13.6141Z"
          fill="#F3FAFF"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="14" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
export function TabActive({ className }) {
  return (
    <svg
      width="12"
      height="14"
      viewBox="0 0 12 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.87484 2.79441H9.28868C9.45568 2.79441 9.59076 2.6299 9.59076 2.4265C9.59076 2.22311 9.45568 2.05859 9.28868 2.05859H5.87484C5.70783 2.05859 5.57275 2.22311 5.57275 2.4265C5.57275 2.6299 5.71029 2.79441 5.87484 2.79441Z"
        fill="#F3FAFF"
      />
      <path
        d="M3.08727 2.90223C3.30158 2.90223 3.47532 2.69064 3.47532 2.42963C3.47532 2.16862 3.30158 1.95703 3.08727 1.95703C2.87295 1.95703 2.69922 2.16862 2.69922 2.42963C2.69922 2.69064 2.87295 2.90223 3.08727 2.90223Z"
        fill="#F3FAFF"
      />
      <path
        d="M9.28868 6.17969H5.87484C5.70783 6.17969 5.57275 6.3442 5.57275 6.5476C5.57275 6.75099 5.70783 6.9155 5.87484 6.9155H9.28868C9.45568 6.9155 9.59076 6.75099 9.59076 6.5476C9.59076 6.3442 9.45568 6.17969 9.28868 6.17969Z"
        fill="#F3FAFF"
      />
      <path
        d="M3.08727 7.01746C3.30158 7.01746 3.47532 6.80587 3.47532 6.54486C3.47532 6.28386 3.30158 6.07227 3.08727 6.07227C2.87295 6.07227 2.69922 6.28386 2.69922 6.54486C2.69922 6.80587 2.87295 7.01746 3.08727 7.01746Z"
        fill="#F3FAFF"
      />
      <path
        d="M9.28868 10.2988H5.87484C5.70783 10.2988 5.57275 10.4633 5.57275 10.6667C5.57275 10.8701 5.70783 11.0346 5.87484 11.0346H9.28868C9.45568 11.0346 9.59076 10.8701 9.59076 10.6667C9.59076 10.4633 9.45568 10.2988 9.28868 10.2988Z"
        fill="#F3FAFF"
      />
      <path
        d="M3.08727 11.1366C3.30158 11.1366 3.47532 10.925 3.47532 10.664C3.47532 10.403 3.30158 10.1914 3.08727 10.1914C2.87295 10.1914 2.69922 10.403 2.69922 10.664C2.69922 10.925 2.87295 11.1366 3.08727 11.1366Z"
        fill="#F3FAFF"
      />
      <path
        d="M12 12.7093V0.367909C12 0.164512 11.8649 0 11.6979 0H0.299632C0.132624 0 0 0.164512 0 0.367909V12.7063C0 12.9097 0.13508 13.0742 0.299632 13.0742H11.7004C11.8674 13.0742 12 12.9097 12 12.7093ZM0.601719 4.8546H11.4007V8.24056H0.601719V4.8546ZM11.3983 0.735817V4.12177H0.601719V0.735817H11.3983ZM0.601719 12.3414V8.97039H11.4007V12.3414H0.601719Z"
        fill="#F3FAFF"
      />
    </svg>
  );
}

export function TabDesactive({ className }) {
  return (
    <svg
      width="12"
      height="14"
      viewBox="0 0 12 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.87435 2.79441H9.28819C9.45519 2.79441 9.59028 2.6299 9.59028 2.4265C9.59028 2.22311 9.45519 2.05859 9.28819 2.05859H5.87435C5.70735 2.05859 5.57227 2.22311 5.57227 2.4265C5.57227 2.6299 5.7098 2.79441 5.87435 2.79441Z"
        fill="#29394D"
      />
      <path
        d="M3.08727 2.90223C3.30158 2.90223 3.47532 2.69064 3.47532 2.42963C3.47532 2.16862 3.30158 1.95703 3.08727 1.95703C2.87295 1.95703 2.69922 2.16862 2.69922 2.42963C2.69922 2.69064 2.87295 2.90223 3.08727 2.90223Z"
        fill="#29394D"
      />
      <path
        d="M9.28819 6.17969H5.87435C5.70735 6.17969 5.57227 6.3442 5.57227 6.5476C5.57227 6.75099 5.70735 6.9155 5.87435 6.9155H9.28819C9.45519 6.9155 9.59028 6.75099 9.59028 6.5476C9.59028 6.3442 9.45519 6.17969 9.28819 6.17969Z"
        fill="#29394D"
      />
      <path
        d="M3.08727 7.01746C3.30158 7.01746 3.47532 6.80587 3.47532 6.54486C3.47532 6.28386 3.30158 6.07227 3.08727 6.07227C2.87295 6.07227 2.69922 6.28386 2.69922 6.54486C2.69922 6.80587 2.87295 7.01746 3.08727 7.01746Z"
        fill="#29394D"
      />
      <path
        d="M9.28819 10.2988H5.87435C5.70735 10.2988 5.57227 10.4633 5.57227 10.6667C5.57227 10.8701 5.70735 11.0346 5.87435 11.0346H9.28819C9.45519 11.0346 9.59028 10.8701 9.59028 10.6667C9.59028 10.4633 9.45519 10.2988 9.28819 10.2988Z"
        fill="#29394D"
      />
      <path
        d="M3.08727 11.1366C3.30158 11.1366 3.47532 10.925 3.47532 10.664C3.47532 10.403 3.30158 10.1914 3.08727 10.1914C2.87295 10.1914 2.69922 10.403 2.69922 10.664C2.69922 10.925 2.87295 11.1366 3.08727 11.1366Z"
        fill="#29394D"
      />
      <path
        d="M12 12.7093V0.367909C12 0.164512 11.8649 0 11.6979 0H0.299632C0.132624 0 0 0.164512 0 0.367909V12.7063C0 12.9097 0.13508 13.0742 0.299632 13.0742H11.7004C11.8674 13.0742 12 12.9097 12 12.7093ZM0.601719 4.8546H11.4007V8.24056H0.601719V4.8546ZM11.3983 0.735817V4.12177H0.601719V0.735817H11.3983ZM0.601719 12.3414V8.97039H11.4007V12.3414H0.601719Z"
        fill="#29394D"
      />
    </svg>
  );
}
export function Profile({ className }) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.684 7.90997C23.4545 7.65815 23.1295 7.5145 22.7887 7.5145H1.21125C0.870534 7.5145 0.545439 7.65815 0.31591 7.90997C0.086381 8.16179 -0.0263849 8.49875 0.00522833 8.83802L1.15651 21.2046C1.21452 21.8274 1.73705 22.3036 2.36253 22.3036H21.6374C22.2629 22.3036 22.7854 21.8273 22.8434 21.2046L23.9947 8.83802C24.0263 8.49875 23.9135 8.16179 23.684 7.90997ZM16.0399 19.7671C16.0391 19.767 16.0383 19.767 16.0375 19.7671H7.96255C7.29359 19.7671 6.75132 19.2247 6.75132 18.5559C6.75132 16.911 8.08949 15.5728 9.73435 15.5728H10.6036C9.70964 15.0789 9.10257 14.1266 9.10257 13.0351C9.10257 11.4374 10.4023 10.1376 12.0001 10.1376C13.5978 10.1376 14.8976 11.4373 14.8976 13.0351C14.8976 14.1266 14.2905 15.0789 13.3965 15.5728H14.2658C15.8771 15.5728 17.1941 16.8571 17.2471 18.4558C17.2498 18.4888 17.2513 18.5222 17.2513 18.5559C17.2511 19.2248 16.7089 19.7671 16.0399 19.7671ZM21.6697 5.25955C21.6697 5.76136 21.263 6.16797 20.7613 6.16797H3.23874C2.73705 6.16797 2.33031 5.76136 2.33031 5.25955C2.33031 4.75773 2.73705 4.35112 3.23874 4.35112H20.7613C21.263 4.35112 21.6697 4.75773 21.6697 5.25955ZM19.2715 1.90843C19.2715 2.41024 18.8647 2.81685 18.3631 2.81685H5.63698C5.13529 2.81685 4.72856 2.41024 4.72856 1.90843C4.72856 1.40661 5.13529 1 5.63698 1H18.3629C18.8647 1 19.2715 1.40661 19.2715 1.90843Z"
        fill="#29394D"
      />
    </svg>
  );
}
export function ArrowLeft({ className }) {
  return (
    <svg
      width="13"
      height="13"
      viewBox="0 0 13 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0)">
        <path
          d="M2.9034 6.44482L8.26838 11.8706C8.50379 12.1081 8.88742 12.1104 9.12617 11.8755C9.36433 11.6407 9.36655 11.2571 9.13114 11.0195L4.1917 6.0243L9.18814 1.08667C9.42629 0.851857 9.42851 0.468229 9.1931 0.230072C8.95769 -0.00748691 8.57346 -0.00971489 8.33531 0.225098L2.90777 5.58827C2.67322 5.82066 2.67096 6.21032 2.9034 6.44482Z"
          fill="#18A0FB"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect
            width="12"
            height="12"
            fill="white"
            transform="translate(12 12.0693) rotate(-179.668)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export function StarIcon(props) {
  const size = props.size | "22";
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      key={props.key}
    >
      <g clipPath="url(#clip0)">
        <path
          d="M20.9461 1.55653L26.0341 13.599L39.0602 14.7181C39.9636 14.7961 40.3312 15.9233 39.6454 16.5167L29.765 25.0769L32.7258 37.8113C32.9311 38.6963 31.9722 39.3924 31.1961 38.9222L20.0016 32.171L8.80711 38.9222C8.02891 39.3903 7.07208 38.6943 7.27741 37.8113L10.2382 25.0769L0.355796 16.5147C-0.33 15.9213 0.0354842 14.794 0.940982 14.716L13.967 13.597L19.055 1.55653C19.4082 0.718788 20.5929 0.718788 20.9461 1.55653Z"
          fill={props.light ? "#C7E8FE" : "#2495E1"}
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="40" height="40" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function FinancialIcon({ className }) {
  return (
    <svg
      width="18"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0)">
        <path
          d="M15.8578 2.62037H14.0484V1.81092C14.0484 1.54903 13.7627 1.43001 13.5008 1.43001H12.0962C11.7629 0.477696 10.9296 0.00154151 9.97732 0.00154151C9.03549 -0.0338659 8.17883 0.543635 7.85843 1.43001H6.47759C6.2157 1.43001 5.95381 1.54903 5.95381 1.81092V2.62037H4.14439C3.07214 2.63181 2.19493 3.47767 2.14453 4.54878V18.1906C2.14453 19.2381 3.09684 19.9999 4.14439 19.9999H15.8578C16.9053 19.9999 17.8576 19.2381 17.8576 18.1906V4.54882C17.8072 3.47767 16.93 2.63181 15.8578 2.62037ZM6.90608 2.38231H8.21551C8.44409 2.35443 8.62769 2.18053 8.66788 1.95378C8.80887 1.33978 9.34755 0.899031 9.97732 0.882444C10.6013 0.901355 11.1318 1.34347 11.2629 1.95378C11.3056 2.18837 11.5013 2.3645 11.7391 2.38231H13.0961V4.28693H6.90608V2.38231ZM16.9053 18.1906C16.9053 18.7144 16.3815 19.0477 15.8578 19.0477H4.14439C3.62062 19.0477 3.09684 18.7144 3.09684 18.1906V4.54882C3.14542 4.00363 3.5971 3.5827 4.14439 3.57272H5.95377V4.78692C5.97892 5.05368 6.20996 5.25323 6.47754 5.23929H13.5008C13.7733 5.25419 14.0116 5.05737 14.0484 4.78692V3.57268H15.8577C16.405 3.5827 16.8567 4.00358 16.9053 4.54878V18.1906H16.9053Z"
          fill="#C7E8FE"
        />
        <path
          d="M8.16933 10.6445C7.99075 10.4563 7.69427 10.4457 7.5027 10.6208L5.979 12.073L5.3362 11.4064C5.15761 11.2181 4.86114 11.2075 4.66956 11.3826C4.48515 11.5758 4.48515 11.8798 4.66956 12.073L5.64566 13.0729C5.73014 13.1675 5.85218 13.2198 5.97895 13.2158C6.10454 13.214 6.22434 13.1626 6.31225 13.0729L8.16924 11.3112C8.35334 11.1423 8.36565 10.8561 8.19672 10.6721C8.18806 10.6624 8.1789 10.6533 8.16933 10.6445Z"
          fill="#C7E8FE"
        />
        <path
          d="M14.9988 11.668H9.52303C9.26005 11.668 9.04688 11.8811 9.04688 12.1441C9.04688 12.4071 9.26005 12.6203 9.52303 12.6203H14.9988C15.2618 12.6203 15.475 12.4071 15.475 12.1441C15.475 11.8811 15.2618 11.668 14.9988 11.668Z"
          fill="#C7E8FE"
        />
        <path
          d="M8.16933 6.83595C7.99075 6.6477 7.69427 6.63708 7.5027 6.81216L5.979 8.26441L5.3362 7.59778C5.15761 7.40953 4.86114 7.39891 4.66956 7.57399C4.48515 7.7672 4.48515 8.0712 4.66956 8.26441L5.64566 9.26434C5.73014 9.35894 5.85218 9.41126 5.97895 9.4072C6.10454 9.40542 6.22434 9.35407 6.31225 9.26434L8.16924 7.50258C8.35334 7.3337 8.36565 7.04752 8.19672 6.86347C8.18806 6.85385 8.1789 6.8447 8.16933 6.83595Z"
          fill="#C7E8FE"
        />
        <path
          d="M14.9988 7.85938H9.52303C9.26005 7.85938 9.04688 8.07255 9.04688 8.33553C9.04688 8.59851 9.26005 8.81168 9.52303 8.81168H14.9988C15.2618 8.81168 15.475 8.59851 15.475 8.33553C15.475 8.07255 15.2618 7.85938 14.9988 7.85938Z"
          fill="#C7E8FE"
        />
        <path
          d="M8.16933 14.4531C7.99075 14.2649 7.69427 14.2543 7.5027 14.4293L5.979 15.8816L5.3362 15.2149C5.15761 15.0267 4.86114 15.0161 4.66956 15.1912C4.48515 15.3844 4.48515 15.6884 4.66956 15.8816L5.64566 16.8815C5.73014 16.9761 5.85218 17.0284 5.97895 17.0244C6.10454 17.0226 6.22434 16.9712 6.31225 16.8815L8.16924 15.1198C8.35334 14.9509 8.36565 14.6647 8.19672 14.4806C8.18806 14.4711 8.1789 14.4619 8.16933 14.4531Z"
          fill="#C7E8FE"
        />
        <path
          d="M14.9988 15.4766H9.52303C9.26005 15.4766 9.04688 15.6897 9.04688 15.9527C9.04688 16.2157 9.26005 16.4289 9.52303 16.4289H14.9988C15.2618 16.4289 15.475 16.2157 15.475 15.9527C15.475 15.6897 15.2618 15.4766 14.9988 15.4766Z"
          fill="#C7E8FE"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function CalendarIcon({ className }) {
  return (
    <svg
      className={className}
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.1165 10.3782V1.63352C17.1165 1.33931 16.878 1.10085 16.5838 1.10085H13.8849V0.53267C13.8849 0.238453 13.6465 0 13.3523 0C13.0581 0 12.8196 0.238453 12.8196 0.53267V1.10085H10.6889V0.53267C10.6889 0.238453 10.4505 0 10.1562 0C9.86203 0 9.62358 0.238453 9.62358 0.53267V1.10085H7.4929V0.53267C7.4929 0.238453 7.25444 0 6.96023 0C6.66601 0 6.42756 0.238453 6.42756 0.53267V1.10085H4.29688V0.53267C4.29688 0.238453 4.05842 0 3.7642 0C3.46999 0 3.23153 0.238453 3.23153 0.53267V1.10085H0.53267C0.238453 1.10085 0 1.33931 0 1.63352V15.5185C0 15.8127 0.238453 16.0511 0.53267 16.0511H9.40358C10.2647 17.335 11.7292 18.1818 13.3878 18.1818C16.0312 18.1818 18.1818 16.0312 18.1818 13.3878C18.1818 12.2489 17.7823 11.2016 17.1165 10.3782ZM3.23153 2.16619V2.69886C3.23153 2.99308 3.46999 3.23153 3.7642 3.23153C4.05842 3.23153 4.29688 2.99308 4.29688 2.69886V2.16619H6.42756V2.69886C6.42756 2.99308 6.66601 3.23153 6.96023 3.23153C7.25444 3.23153 7.4929 2.99308 7.4929 2.69886V2.16619H9.62358V2.69886C9.62358 2.99308 9.86203 3.23153 10.1562 3.23153C10.4505 3.23153 10.6889 2.99308 10.6889 2.69886V2.16619H12.8196V2.69886C12.8196 2.99308 13.0581 3.23153 13.3523 3.23153C13.6465 3.23153 13.8849 2.99308 13.8849 2.69886V2.16619H16.0511V4.29688H1.06534V2.16619H3.23153ZM1.06534 14.9858V5.36222H16.0511V9.40358C15.2889 8.89241 14.3725 8.59375 13.3878 8.59375C11.7046 8.59375 10.2214 9.46586 9.36584 10.7817C9.29385 10.7454 9.2127 10.7244 9.12642 10.7244H8.06108C7.76686 10.7244 7.52841 10.9629 7.52841 11.2571C7.52841 11.5513 7.76686 11.7898 8.06108 11.7898H8.86799C8.74773 12.1291 8.6645 12.4859 8.62357 12.8551H8.06108C7.76686 12.8551 7.52841 13.0936 7.52841 13.3878C7.52841 13.682 7.76686 13.9205 8.06108 13.9205H8.62357C8.6645 14.2897 8.74759 14.6465 8.86799 14.9858H1.06534ZM13.3878 17.1165C11.3317 17.1165 9.65909 15.4438 9.65909 13.3878C9.65909 11.3317 11.3317 9.65909 13.3878 9.65909C15.4438 9.65909 17.1165 11.3317 17.1165 13.3878C17.1165 15.4438 15.4438 17.1165 13.3878 17.1165Z"
        fill="#3C4E64"
      />
      <path
        d="M15 12.7274H13.6364V11.3637C13.6364 11.1127 13.4329 10.9092 13.1818 10.9092C12.9308 10.9092 12.7273 11.1127 12.7273 11.3637V13.1819C12.7273 13.433 12.9308 13.6365 13.1818 13.6365H15C15.2511 13.6365 15.4546 13.433 15.4546 13.1819C15.4546 12.9308 15.2511 12.7274 15 12.7274Z"
        fill="#3C4E64"
      />
    </svg>
  );
}
export function RedirectIcon({ className }) {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clippath="url(#clip0)">
        <path
          d="M11.4542 0H7.09053C6.78929 0 6.54507 0.244219 6.54507 0.545461C6.54507 0.846703 6.78929 1.09092 7.09053 1.09092H10.1373L4.52305 6.70524C4.31003 6.91826 4.31003 7.26359 4.52305 7.47661C4.62953 7.58311 4.76912 7.63636 4.90871 7.63636C5.04831 7.63636 5.18792 7.58313 5.29442 7.47659L10.9087 1.8623V4.9091C10.9087 5.21034 11.153 5.45456 11.4542 5.45456C11.7554 5.45456 11.9997 5.21034 11.9997 4.9091V0.545461C11.9996 0.244219 11.7554 0 11.4542 0Z"
          fill="#29394D"
        />
        <path
          d="M9.27272 5.45485C8.97148 5.45485 8.72726 5.69907 8.72726 6.00031V10.9094H1.0909V3.27303H6C6.30124 3.27303 6.54546 3.02881 6.54546 2.72757C6.54546 2.42632 6.30124 2.18213 6 2.18213H0.545461C0.244219 2.18213 0 2.42635 0 2.72759V11.4549C0 11.7561 0.244219 12.0003 0.545461 12.0003H9.27274C9.57398 12.0003 9.8182 11.7561 9.8182 11.4548V6.00031C9.81818 5.69907 9.57396 5.45485 9.27272 5.45485Z"
          fill="#29394D"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="12" height="12" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function CheckMarkCircleIcon({ className, width }) {
  return (
    <svg
      width={width ? width : "24"}
      height={width ? width : "24"}
      viewBox="0 0 24 24"
      fill="white"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect width="24" height="24" rx="12" />
      <g clip-path="url(#clip0_45967_24443)">
        <path
          d="M10.758 17.1003C10.4409 17.1003 10.141 16.952 9.94826 16.6976L7.34464 13.2591C7.006 12.8119 7.09415 12.1752 7.54135 11.8364C7.98928 11.4975 8.62561 11.5862 8.9644 12.0331L10.6768 14.2943L14.9837 7.37899C15.2802 6.90323 15.9064 6.75767 16.3832 7.05376C16.8593 7.35014 17.0048 7.97671 16.7081 8.45291L11.6203 16.6216C11.4436 16.9056 11.1385 17.0843 10.8043 17.0994C10.7887 17.1 10.7734 17.1003 10.758 17.1003Z"
          fill="#02AF8E"
        />
      </g>
    </svg>
  );
}

export function CrossIcon({ className, width, color }) {
  return (
    <svg
      width={width ? width : "14"}
      height={width ? width : "14"}
      viewBox="0 0 14 14"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M5.33562 6.99954L0.344101 2.00802C-0.115375 1.54855 -0.115375 0.803594 0.344101 0.344184C0.803576 -0.115291 1.54847 -0.115291 2.00794 0.344184L6.99953 5.33577L11.9911 0.344118C12.4506 -0.115357 13.1955 -0.115357 13.655 0.344118C14.1144 0.803594 14.1144 1.54855 13.655 2.00796L8.66337 6.99948L13.655 11.9911C14.1144 12.4505 14.1144 13.1955 13.655 13.6549C13.1955 14.1144 12.4506 14.1144 11.9911 13.6549L6.99953 8.66332L2.00794 13.6549C1.54853 14.1144 0.803576 14.1144 0.344101 13.6549C-0.115375 13.1954 -0.115375 12.4505 0.344101 11.9911L5.33562 6.99954Z"
        fill={color ? color : "#3C4E64"}
      />
    </svg>
  );
}



// WEBPACK FOOTER //
// ./src/components/Common/Icons/index.js